// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `textarea,
input {
	overflow: hidden !important;
}

#loader_blue {
	width: 10vw;
	animation: rotate_loader 3s linear infinite;
}

@keyframes rotate_loader {
	from {
		transform: rotate(0deg);
	}

	to {
		transform: rotate(360deg);
	}
}

/* WelcomePage */
.container_principal_welcome {
	width: 100vw;
	min-height: 83vh;
	padding: 5vw 0vh;
	color: #6c757d;
	margin: auto;
	display: flex;
	justify-content: space-around;
	background-color: #fafafa;
}

.container_texto_welcome {
	max-width: 30vw;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
}

.texto_welcome {
	font-size: 25px;
	font-weight: 500;
}

.texto_banco {
	font-size: 25px;
	font-weight: 500;
}

.texto_recursos {
	font-size: 72px;
	font-weight: 700;
	color: #3b82f5;
	text-transform: uppercase;
	line-height: 0.9;
}
.texto_name {
	font-size: 25px;
	font-weight: 500;
}

.texto_name span {
	color: #f02323;
	font-weight: 700;
}

.btn_login {
	border: none;
	min-width: 10vw;
	background-color: #3b82f5;
	color: #ffffff;
	padding: 0.6vh 1.5vw;
	border-radius: 5px;
	margin-top: 2%;
	text-transform: uppercase;
	font-weight: 500;
	display: flex;
	justify-content: space-between;
	align-items: center;
	font-size: 15px;
}

.container_video {
	width: 60vw;
}

/* HomePage */

.HomePage_main_container {
	width: 100vw;
	min-height: 80vh;
	padding: 0vh 0vw;
	display: flex;
	justify-content: center;
	flex-direction: column;
	background-color: #fafafa;
}

.HomePage_search_container {
	margin: 4vh auto;
	width: 90%;
	min-height: 120px;
	background-color: #3b82f5;
	/* padding: 5vw 10vh; */
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	border-radius: 10px;
}

.HomePage_middle_text {
	width: 100%;
	text-align: center;
	color: #fafafa;
	font-size: 18px;
	font-weight: 600;
	font-family: "Roboto", sans-serif;
	margin-top: 3vh;
}

.HomePage_title {
	padding: 0;
	width: 100%;
	height: 60px;
	display: flex;
	align-content: center;
	align-items: center;
	align-self: auto;
	justify-content: center;
	color: #ffffff;
	font-size: 50px;
	text-shadow: 1px 1px 20px #00000095;
	font-weight: 600;
	font-family: "Roboto", sans-serif;
}

.HomePage_div_input {
	width: 50%;
	margin: 30px auto;
	display: flex;
	justify-content: center;
}

.HomePage_div_input input {
	width: 100%;
	border: none;
	border-radius: 10px 0px 0px 10px;
	padding-left: 30px;
}

.HomePage_div_input button {
	width: 60px;
	height: 150%;
	background-color: #ffffff;
	border: none;
	border-radius: 0px 10px 10px 0px;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 10px 0px;
}

.HomePage_container_icons {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	align-self: center;
	justify-self: center;
	justify-content: space-around;
	align-content: space-around;
	margin: 0.5vw;
}

.HomePage_container_icons a {
	text-decoration: none;
	color: #6c6565 !important;
}

.HomePage_card_icons {
	width: 20%;
	width: 100px;
	height: 100px;
	box-shadow: 0px 4px 10px #afc1de;
	border-radius: 10px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin: 0.5vw;
	color: #6c6565;
}

.HomePage_cardTipo_Tipo {
	font-size: 14px;
	width: 100%;
	text-align: center;
}

.HomePage_Secton_Tipos {
	width: 90vw;
	margin: 2em auto;
	display: flex;
	flex-wrap: wrap;
}

.HomePage_Fade_In {
	display: flex;
	flex-wrap: wrap;
}

/* SearchPage */

#notFoundImage {
	width: 20%;
	margin-bottom: 1em;
}

.SearchPage_NotFound {
	text-align: center;
	color: #3b82f5;
	font-size: 20px;
}

.SearchPage_NotFound_Text {
	display: flex;
	justify-content: center;
	align-items: center;
	font-weight: 400;
	text-wrap: wrap;
	width: 50%;
	margin: auto;
}

.SearchPage_NotFound_Text p {
	margin-top: 0.5em;
	color: #dc3545;
	font-size: 16px;
}

.SearchPage_main_container {
	width: 100vw;
	min-height: 80vh;
	background-color: #fafafa;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 3vh 0em;
}

.SearchPage_container_form {
	width: 90vw;
	margin: 5vh auto;
	gap: 1em;
	height: 100%;
	display: flex;
	justify-content: space-around;
	align-content: space-around;
	font-family: "Roboto", sans-serif;
	color: #444444;
	font-weight: 400;
	font-size: 18px;
	flex-wrap: wrap;
}

.SearchPage_container_form input,
.SearchPage_container_form select {
	width: 45%;
	height: 35px;
	padding: 0.375rem 0.75rem;
	font-size: 12px;
	font-weight: 400;
	line-height: 1.5;
	color: #212529;
	background-color: #fff;
	background-clip: padding-box;
	border: 1px solid #ced4da;
	appearance: none;
	border-radius: 0.375rem;
	transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.SearchPage_div_btn {
	width: 100%;
	display: flex;
	justify-content: center;
}

.SearchPage_container_form button {
	width: 30%;
	background-color: #3b82f5;
	border: none;
	font-weight: 600;
	padding: 1vh 2vw;
	font-family: "Roboto", sans-serif;
	font-size: 15px;
	text-transform: uppercase;
	align-self: flex-end;
	color: #ffffff;
	border-radius: 5px;
}

.SearchPage_divisor {
	width: 50vw;
	border: 0.1px solid #958c8c29;
}

.SearchPage_search_results {
	width: 80vw;
	padding: 2vh;
	display: flex;
	/* justify-content: space-around; */
	align-items: center;
	flex-wrap: wrap;
	overflow-y: auto;
}

.SearchPage_Fade_In {
	display: flex;
	flex-wrap: wrap;
}

.SearchPage_card_result {
	width: 100%;
	min-height: 20vh;
	box-shadow: 0px 4px 10px #958c8c29;
	padding: 10px 20px;
	display: flex;
	flex-direction: row;
	align-items: center;
	align-self: center;
	font-family: "Roboto", sans-serif;
	cursor: pointer;
	border-radius: 5px;
	margin: 1vh 1vw;
	background-color: #fcfcfc;
}

.SearchPage_Fade_In_Child {
	max-width: 45%;
	margin: 0vh 1vw;
}

.SearchPage_card_result a {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	align-self: center;
}

.SearchPage_card_img {
	width: 20%;
	margin: 1vh 2vw;
	box-shadow: 0px 4px 10px #958c8c29;
	border-radius: 5px;
	background-color: #fcfcfc;
}

.SearchPage_card_img img {
	width: 100%;
	border-radius: 5px;
}

.SearchPage_card_type {
	font-family: "Roboto", sans-serif;
	text-align: left;
}

.SearchPage_card_reference {
	font-size: 13px;
	color: #6c6565;
	font-weight: lighter;
}

.SearchPage_card_description {
	font-size: 14px;
	color: #6c6565;
	text-overflow: ellipsis;
	overflow: hidden;
	font-weight: lighter;
	white-space: nowrap;
	max-width: 300px;
}

.SearchPage_actualPage {
	color: #6c6565;
	font-family: "Roboto", sans-serif;
}

/* Exhibition Card */

.ExhibitionCard_container_image {
	width: 90%;
	margin-bottom: 1em;
	min-height: 30%;
}

.ExhibitionCard_container_image img {
	width: 100%;
	border-radius: 5px;
}

/* Exhibition Pop up */

.Exhibition_popup_container {
	width: 100vw;
	min-height: 100vh;
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	background: rgba(0, 0, 0, 0.7);
	padding: 1em 3em;
	z-index: 1000;
	display: flex;
	justify-content: center;
	align-items: center;
}
.Exhibition_popup_container_inner {
	width: 90%;
	height: 80%;
	background-color: #ffffff;
	border-radius: 10px;
	padding: 3em 3em 3em 5em;
}

.Exhibition_popup_container_close {
	text-align: end;
	height: 30%;
	padding: 0;
}

.ExhibitionCard_container_exibhition_card {
	font-family: "Roboto", sans-serif;
	width: 80vw;
	display: flex;
	justify-content: space-between;
	margin: auto;
}
.ExhibitionCard_div_esquerda_exhibition_card {
	width: 40%;
	display: flex;
	flex-direction: column;
	padding: 0vh 2vw;
}
.ExhibitionCard_div_direita_exhibition_card {
	width: 60%;
	border-left: 1px solid #00000010;
	padding: 0vh 2vw;
}
.ExhibitionCard_image_exhibition_card {
	width: 90%;
}
.ExhibitionCard_descricao_exhibition_card {
	width: 90%;
	max-height: 250px;
	overflow: hidden;
	padding: 10px 20px;
	border-radius: 5px;
	background-color: #00000020;
	font-size: 12px;
	display: flex;
	gap: 10px;
	align-items: center;
	cursor: pointer;
	text-align: justify;
}
.ExhibitionCard_observacao_exhibition_card {
	width: 90%;
	padding: 10px 20px;
	border-radius: 5px;
	background-color: #ffffff;
	font-size: 12px;
	gap: 15px;
	align-items: center;
	cursor: pointer;
	box-shadow: 1px 1px 60px #00000005;
	border: 1px solid #00000020;
	margin-top: 2vh;
}
.ExhibitionCard_referencia_exhibition_card {
	width: 90%;
	padding: 0.5vh 1vw;
	font-size: 13px;
	margin: 0vh 0vw;
	background-color: #3b82f5;
	color: #ffffff;
	font-weight: bold;
	border-radius: 3px;
}
.ExhibitionCard_referencia_exhibition_card span {
	font-weight: bold;
	margin-right: 3px;
}

.ExhibitionCard_container_tags {
	width: 90%;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	flex-wrap: wrap;
	box-shadow: 1px 1px 60px #00000005;
	border: 1px solid #00000020;
	margin-top: 2vh;
	padding: 10px 20px;
	border-radius: 5px;
	background-color: #ffffff;
}

.ExhibitionCard_container_tags span {
	font-weight: bold;
	margin-right: 3px;
	font-size: 12px;
	display: flex;
	align-items: center;
}

.ExhibitionCard_projetos_exhibition_card {
	width: 90%;
	flex-wrap: wrap;
	box-shadow: 1px 1px 60px #00000005;
	border: 1px solid #00000020;
	margin-top: 2vh;
	padding: 10px 20px;
	display: flex;
	border-radius: 5px;
	background-color: #ffffff;
}
.ExhibitionCard_proj_original_exhibition_card {
}
.ExhibitionCard_link_exhibition_card {
	width: 90%;
	border-radius: 5px;
	background-color: #00000020;
	padding: 0.5vh 2vw;
	font-size: 12px;
	margin: 1vh 0vw;
	text-align: left;
}

.ExhibitionCard_link_exhibition_card span {
	font-weight: bold;
	margin-right: 3px;
}

.ExhibitionCard_origem_exhibition_card {
	margin-bottom: 0.5em;
	padding-bottom: 0.5em;
	border-bottom: 0.5px solid #3b82f5;
	font-size: 12px;
}

.ExhibitionCard_origem_exhibition_card span {
	font-weight: bold;
	margin-right: 3px;
}

.ExhibitionCard_info_exhibition_card {
	width: 90%;
	padding: 0.5vh 2vw;
	font-size: 12px;
	margin: 1vh 0vw;
	box-shadow: 1px 1px 60px #00000005;
	border: 1px solid #00000020;
	border-radius: 5px;
}

.ExhibitionCard_info_exhibition_card span {
	font-weight: bold;
	margin-right: 5px;
}

.ExhibitionCard_botoes_exhibition_card {
	width: 90%;
	display: flex;
	justify-content: space-around;
	padding: 0.5vh 2vw;
}

.ExhibitionCard_botoes_exhibition_card button {
	border: none;
	width: 10vw;
	border-radius: 5px;
	padding: 1vh 2 vw;
	font-weight: bold;
	color: #ffffff;
	background-color: #3b82f5;
}

/* RegisterPage */

.RegisterPage_main_container {
	width: 100vw;
	min-height: 80vh;
	background-color: #ffffff;
	/* padding: 5vh 5vw; */
	text-align: center;
}

.RegisterPage_btn_confirm {
	border: none;
	background-color: #008000;
	color: #ffffff;
	padding: 0.5vh 2vw;
	border-radius: 6px;
}

.RegisterPage_btn_confirm:disabled {
	background-color: #dcdcdc;
}

.RegisterPage_container_form {
	display: flex;
	justify-content: space-around;
	width: 100%;
	overflow: scroll;
	padding: 2em 1em;
	background-color: #ffffff;
	/* box-shadow: 0px 0px 4px #dcdcdc; */
	border-top: 0.5px solid #dcdcdc;
}

.RegisterPage_Input_Image {
	border: 1px dashed #3b82f5;
	border-radius: 5px;
	width: 100%;
	margin: auto;
	height: 35vh;
}

.RegisterPage_image_loaded {
	margin: auto;
	max-height: 60%;
}

.RegisterPage_container_image {
	width: 47vw;
	min-height: 400px;
	padding-right: 5vw;
	display: flex;
	flex-direction: column;
	align-items: space-around;
	/* justify-content: space-between; */
}

.RegisterPage_container_image img {
	max-width: 70%;
	border-radius: 5px;
}

.RegisterPage_container_informations {
	width: 47vw;
}

.RegisterPage_description {
	width: 100%;
	font-family: "Roboto", sans-serif;
	border-radius: 5px;
	/* box-shadow: 0px 0px 4px #9fc0f5; */
	border: 1px solid #dcdcdc !important;
	border: none;
	background: #ffffff;
	padding: 15px;
	font-style: italic;
	resize: none;
}

.RegisterPage_container_tags {
	display: flex;
	flex-wrap: wrap;
	margin-top: 1em;
	padding-top: 5px;
	flex-direction: row;
	max-height: 65px;
	overflow: auto;
	text-align: justify;
}
.RegisterPage_container_master_tags {
	font-family: "Roboto", sans-serif;
	border-radius: 5px;
	/* box-shadow: 0px 0px 4px #9fc0f5; */
	border: 1px solid #dcdcdc !important;
	background: #ffffff;
	color: #b1b1b1;
	padding: 15px;
	font-style: italic;
}
.RegisterPage_input_search_style {
	width: 100%;
	border: none;
	border-bottom: 0.5px solid #9fc0f5;
	background-color: transparent;
	font-family: "Roboto", sans-serif;
	color: #b1b1b1;
	font-style: italic;
}

.RegisterPage_Selected_Tag {
	background-color: transparent;
	color: #6c6565;
	font-size: 12px;
	padding-left: 1vw;
	border: none;
}

.RegisterPage_Sugested_Tag {
	background-color: transparent;
	color: #41a5d7;
	font-size: 12px;
	margin-left: 0px;
	border: none;
}

.RegisterPage_container_links {
	display: flex;
	flex-wrap: wrap;
	width: 100%;
	justify-content: space-between;
	padding: 3vh 0vw;
}

.RegisterPage_input_wrap {
	display: flex;
	flex-direction: column;
	width: 50%;
}

.RegisterPage_input_wrap label {
	font-size: 12px;
}

.span1 {
	font-weight: 600;
	margin-right: 1em;
}

.span2 {
	font-weight: 700;
	color: #ff0000;
}

.span3 {
	color: #ff0000;
}

.RegisterPage_container_links input {
	width: 95%;
	margin: 0.5vh 0vw;
	background-color: #ffffff;
	/* box-shadow: 0px 0px 4px #9fc0f5; */
	border: 1px solid #dcdcdc !important;
	border-radius: 5px;
	font-size: 12px;
	padding: 0.5vh 2vw;
}

.rightLink {
	box-shadow: 0px 0px 4px #9fc0f5 !important;
}

.wrongLink {
	/* box-shadow: 0px 0px 12px #FF0000 !important; */
	background-color: #ff0000;
	color: #ff0000;
	outline: 2px solid #ff0000 !important;
}

.RegisterPage_container_projects {
	width: 100%;
	/* padding: 2vh 3vw; */
	display: flex;
	justify-content: space-around;
	align-items: center;
	background-color: #ffffff;
	/* border: 1px solid #707070;
    border-radius: 6px; */
	font-size: 15px;
	margin-bottom: 1vh;
}

.RegisterPage_container_projects select {
	width: 100%;
	height: 80%;
	font-size: 13px;
	border-radius: 5px;
	box-shadow: 0px 0px 4px #9fc0f5;
	border: none;
	color: #3b82f5;
}

.label_origin {
	font-size: 12px;
	font-weight: 600;
	margin-top: 2vh;
}

.RegisterPage_container_origin {
	width: 100%;
	padding: 0px;
	border: 1px solid #dcdcdc !important;
	justify-content: space-between;
	border-radius: 5px;
	display: flex;
	flex-direction: column;
}

.RegisterPage_container_origin select {
	width: 100%;
	align-self: flex-end;
	font-size: 13px;
	border: none;
	background-color: #ffffff;
	border-bottom: 0.5px solid #9fc0f5;
	padding: 10px;
}

.RegisterPage_container_origin textarea {
	width: 100%;
	font-size: 13px;
	border: none;
	background-color: #ffffff;
	resize: none;
}

.RegisterForm_select {
	width: 100%;
	margin-bottom: 0.5em;
	border: 1px solid #dcdcdc !important;
	padding: 0.5em 3em;
	border-radius: 5px;
	color: #212529;
}

.RegisterPage_Confirmation_popup_container {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
}

.RegisterPage_div_btn {
	width: 100%;
	text-align: center;
	margin-bottom: 2vh;
	background-color: #ffffff;
}

.RegisterPage_Content_Style {
	background: white;
	padding: 20px;
	border-radius: 8px;
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
	text-align: center;
}

.RegisterPage_Content_Style p {
	color: #3b82f5;
	font-size: 18px;
	font-weight: 500;
}

.RegisterPage_PopUp_confirm_btn {
	border: none;
	background-color: green;
	color: #ffffff;
	width: 7em;
	border-radius: 5px;
	margin: 0.5em 1em;
}

.RegisterPage_PopUp_cancel_btn {
	border: none;
	background-color: red;
	color: #ffffff;
	width: 7em;
	border-radius: 5px;
	margin: 0.5em 1em;
}

.RegisterPage_Text1 {
	font-size: 18px;
	font-weight: 600;
	color: #02c028;
	display: flex;
	align-items: center;
}

.RegisterPage_Text2 {
	font-size: 13px;
	font-weight: 600;
}
.RegisterPage_Text2 span {
	font-weight: 400;
	font-size: 12px;
}

.container_exhibition_created {
	width: 90%;
	max-height: 100%;
	margin: auto;
	object-fit: contain;
	overflow: hidden;
}

/* SettingsPage */

.SettingsPage_main_container {
	width: 100vw;
	min-height: 80vh;
	background-color: #fafafa;
	padding: 5vh 5vw;
	text-align: center;
}

.SettingsPage_container_admins {
	box-shadow: 0px 1px 50px #b9b6b640;
	border-radius: 10px;
	padding: 0.5em 5vw;
	min-height: min-content;
	font-family: "Roboto", sans-serif;
	font-size: large;
	font-weight: bold;
	display: flex;
	flex-direction: column;
	justify-content: space-around;
	margin: 30px 0px;
}

.SettingsPage_admin_line {
	display: flex;
	width: 100%;
	justify-content: space-around;
	margin: 0.5em;
	font-family: "Roboto", sans-serif;
	font-weight: 300;
	font-size: larger;
	color: #707070;
}

.SettingsPage_admin_column {
	width: 25%;
	text-align: left;
	display: flex;
}

#SettingsPage_btn_Administradores {
	width: 5vw;
	display: flex;
	align-items: center;
	justify-content: space-around;
	color: #241571;
	background-color: transparent;
	border: 1px solid #241571;
	border-radius: 5px;
	margin: 1em auto;
}

#SettingsPage_btn_Edit {
	color: green;
	border: 1px solid green;
	display: flex;
	justify-content: space-around;
	align-items: center;
	border-radius: 5px;
	width: 5vw;
	font-size: 17px;
	background-color: transparent;
}

#SettingsPage_btn_Delete {
	color: red;
	border: 1px solid red;
	display: flex;
	justify-content: space-around;
	align-items: center;
	border-radius: 5px;
	width: 5vw;
	font-size: 17px;
	background-color: transparent;
	margin: auto;
}

/* MyRecordsPage */

.MyRecordsPage_main_container {
	width: 100vw;
	min-height: 80vh;
	background-color: #fafafa;
	padding: 5vh 5vw;
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;
	text-align: center;
}

/* EditPage */

.EditPage_Input_Image {
	border: 1px dashed #3b82f5;
	border-radius: 5px;
	width: 100%;
	margin: 2em auto;
	height: 5vh;
}

.EditPage_image_loaded {
	margin: auto;
	max-height: 40%;
}

#btn_formulario {
	border: 1px solid #008000;
	border-radius: 5px;
	min-width: 8em;
	color: #ffffff;
	background-color: #008000;
	margin: 1em auto;
	box-shadow: 0px 0.5px 5px #fafafa;
	margin: 0 3em;
	display: flex;
	justify-content: space-around;
	align-items: center;
	font-weight: 500;
}

.edit_final_btns {
	display: flex;
	justify-content: space-around;
	align-items: center;
	padding: 2em 0;
}

#btn_cancel_edit {
	border: 1px solid #ff0000;
	min-width: 8em;
	border-radius: 5px;
	color: #ffffff;
	background-color: #ff0000;
	box-shadow: 0px 0.5px 5px #fafafa;
	margin: 0 3em;
	display: flex;
	justify-content: space-around;
	align-items: center;
	font-weight: 500;
}

/* AboutPage */

.AboutPage_main_container {
	width: 100vw;
	padding: 3vh 5vw;
	min-height: 83vh;
	background-color: #fafafa;
}

.AboutPage_title {
	display: flex;
	margin-bottom: 1.5em;
	justify-content: center;
}

.AboutPage_title_separator {
	margin: 0vh 1vw;
	border: 1px solid #6c6565;
}

.AboutPage_title_main {
	font-size: 19px;
	color: #6c6565;
	align-items: center;
}

.AboutPage_title_main span {
	color: #3b82f5;
	text-transform: uppercase;
	font-weight: 800;
}

.AboutPage_title_name {
	font-size: 19px;
	color: #6c6565;
	align-items: center;
}

.AboutPage_title_name span {
	color: #f02323;
	text-transform: uppercase;
	font-weight: 800;
}

.AboutPage_container_division {
	margin-top: 1.5em;
	display: flex;
	justify-content: space-between;
}

.AboutPage_left {
	width: 50%;
	text-wrap: wrap;
	text-align: justify;
}

.AboutPage_left a {
	text-decoration: none;
	color: inherit;
}

.AboutPage_section_tipos {
	width: 100%;
	display: flex;
	flex-wrap: wrap;
}

.AboutPage_card_tipo {
	width: 100px;
	margin: 1vw;
}

.AboutPage_card_tipo a {
	text-decoration: none;
}

.AboutPage_card_tipo p {
	font-size: 12px;
	margin-top: 1vh;
	margin-bottom: 0em;
	text-align: center;
}

.AboutPage_card_icons {
	min-width: 100%;
	min-height: 90px;
	/* border: 1px solid #cfcdcd; */
	box-shadow: 0px 4px 10px #afc1de;
	border-radius: 7px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	color: #6c6565;
	padding: 1vh;
}

.AboutPage_right {
	width: 50%;
	padding: 0vh 3vw;
}

.AboutPage_Badges {
	display: flex;
	flex-wrap: wrap;
	justify-content: left;
}

.AboutPage_Badges img {
	margin-right: 0.5vw;
	margin-top: 1vh;
	border-radius: 3px;
	/* box-shadow: 0px 4px 10px #afc1de; */
}

#AboutPage_Dev_Master_div {
	display: flex;
	padding: 2vh 0em;
}

#AboutPage_Dev_Contacts {
	display: flex;
	justify-content: space-around;
	padding: 0em 1vw;
}

.AboutPage_Dev_Badges {
	margin-left: 1.5vw;
	display: flex;
	justify-content: left;
	align-items: center;
}

.AboutPage_Dev_Badges a {
	margin-right: 1vw;
}

/* #AboutPage_Dev_Contacts a{
    margin-top: 1vh;
} */

#AboutPage_Dev_Contacts a img {
	border-radius: 3px;
}

.nomeSenai {
	color: #f02323;
	text-transform: uppercase;
	font-weight: 800;
}

.Error_PopUp_Container {
	width: 100%;
	height: 100vh;
	position: fixed;
	top: 0;
	background-color: rgba(0, 0, 0, 0.5);
	padding: 2vh 3vw;
	z-index: 1000;
}

.ErrorPopUp_Content {
	margin-top: 4vh;
	text-align: center;
	background-color: #ffffff;
	border-radius: 10px;
	padding: 3em 2em;
}

.ErrorPage_Container {
	width: 100%;
	height: 100vh;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	background-color: #fafafa;
}

.GeneralErrorPopUp_Content {
	margin-top: 4vh;
	text-align: center;
	padding: 0 3em;
}

.ErrorPopUp_Content h5,
.GeneralErrorPopUp_Content h5 {
	color: red;
}

.GeneralErrorPopUp_Content p {
	color: #3b82f5;
}

.GeneralError_img_container {
	width: 20%;
	margin: 2em auto;
}

.ErrorPopUp_Content p {
	color: #666666;
	font-size: 13px;
}

.NotFound_Container {
	min-height: 80vh;
	display: flex;
	align-items: center;
	justify-content: center;
}

.RedirectInitialPage {
	font-size: 15px;
	margin-top: 1em;
}

.PopUpErrorLogin_container {
	width: 50%;
	min-height: 30%;
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	background-color: white;
	box-shadow: 0px 0px 10px #6c6565;
	border-radius: 10px;
	z-index: 1000;
	text-align: center;
	padding-bottom: 2em;
}

.PopUpErrorLogin_main {
	color: #ffffff;
	font-weight: 600;
	padding: 1em;
	font-size: 25px;
	border-radius: 10px 10px 0px 0px;
	background-color: #3b82f5;
}

.PopUpErrorLogin_main svg {
	margin-right: 15px;
}

.PopUpErrorLogin_text {
	padding-top: 4vh;
	padding-bottom: 3vh;
}

.PopUpErrorLogin_erro {
	color: red;
	margin-top: 1vh;
}

.PopUpErrorLogin_Dev_Info {
	border-top: 1px solid #6c6565;
	border-bottom: 1px solid #6c6565;
	text-transform: uppercase;
	font-size: 15px;
}

.PopUpErrorLogin_container button {
	background-color: #ffffff;
	color: #008f39;
	border: 1px solid #008f39;
	border-radius: 5px;
	padding: 0.5vh 2vw;
	box-shadow: 0px 0px 5px #6c6565;
	margin-top: 2vh;
}

.waitingFor {
	width: 100%;
	height: 100vh;
	position: fixed;
	top: 0%;
	left: 50%;
	transform: translate(-50%, 0%);
	background-color: rgba(0, 0, 0, 0.5);
	box-shadow: 0px 0px 10px #6c6565;
	z-index: 1001;
	align-items: center;
	padding-top: 30vh;
}

.waitingFor_text {
	text-align: center;
	width: 100%;
	color: #ffffff;
	font-size: 60px;
	font-weight: 600;
	text-transform: uppercase;
}

/* Responsive */

@media (max-width: 1400px) {
	.menu-options a {
		font-size: 13px;
		padding: 0 1vw;
	}

	.GeneralError_img_container {
		width: 40%;
		margin: 2em auto;
	}

	/* WelcomePage */
	.container_principal_welcome {
		width: 100vw;
		min-height: 83vh;
		padding: 5vw 0vh;
		color: #6c757d;
		margin: auto;
		display: flex;
		justify-content: space-around;
		background-color: #fafafa;
	}

	.container_texto_welcome {
		max-width: 30vw;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: center;
	}

	.texto_welcome {
		font-size: 25px;
		font-weight: 500;
	}

	.texto_banco {
		font-size: 25px;
		font-weight: 500;
	}

	.texto_recursos {
		font-size: 72px;
		font-weight: 700;
		color: #3b82f5;
		text-transform: uppercase;
		line-height: 0.9;
	}
	.texto_name {
		font-size: 25px;
		font-weight: 500;
	}

	.texto_name span {
		color: #f02323;
		font-weight: 700;
	}

	.btn_login {
		border: none;
		min-width: 10vw;
		background-color: #3b82f5;
		color: #ffffff;
		padding: 0.6vh 1.5vw;
		border-radius: 5px;
		margin-top: 2%;
		text-transform: uppercase;
		font-weight: 500;
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 15px;
	}

	.container_video {
		width: 60vw;
	}

	/* HomePage */

	.HomePage_main_container {
		width: 100vw;
		min-height: 80vh;
		padding: 0vh 0vw;
		display: flex;
		justify-content: center;
		flex-direction: column;
		background-color: #fafafa;
	}

	.HomePage_search_container {
		margin: 4vh auto;
		width: 90%;
		min-height: 120px;
		background-color: #3b82f5;
		/* padding: 5vw 10vh; */
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		border-radius: 10px;
	}

	.HomePage_middle_text {
		width: 100%;
		text-align: center;
		color: #fafafa;
		font-size: 18px;
		font-weight: 600;
		font-family: "Roboto", sans-serif;
		margin-top: 3vh;
	}

	.HomePage_title {
		padding: 0;
		width: 100%;
		height: 60px;
		display: flex;
		align-content: center;
		align-items: center;
		align-self: auto;
		justify-content: center;
		color: #ffffff;
		font-size: 50px;
		text-shadow: 1px 1px 20px #00000095;
		font-weight: 600;
		font-family: "Roboto", sans-serif;
	}

	.HomePage_div_input {
		width: 50%;
		margin: 30px auto;
		display: flex;
		justify-content: center;
	}

	.HomePage_div_input input {
		width: 100%;
		border: none;
		border-radius: 10px 0px 0px 10px;
		padding-left: 30px;
	}

	.HomePage_div_input button {
		width: 60px;
		height: 150%;
		background-color: #ffffff;
		border: none;
		border-radius: 0px 10px 10px 0px;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 10px 0px;
	}

	.HomePage_container_icons {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		align-self: center;
		justify-self: center;
		justify-content: space-around;
		align-content: space-around;
		margin: 0.5vw;
	}

	.HomePage_container_icons a {
		text-decoration: none;
		color: #6c6565 !important;
	}

	.HomePage_card_icons {
		width: 20%;
		width: 100px;
		height: 100px;
		box-shadow: 0px 4px 10px #afc1de;
		border-radius: 10px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin: 0.5vw;
		color: #6c6565;
	}

	.HomePage_cardTipo_Tipo {
		font-size: 14px;
		width: 100%;
		text-align: center;
	}

	.HomePage_Secton_Tipos {
		width: 90vw;
		margin: 2em auto;
		display: flex;
		flex-wrap: wrap;
	}

	.HomePage_Fade_In {
		display: flex;
		flex-wrap: wrap;
	}

	/* SearchPage */

	.SearchPage_main_container {
		width: 100vw;
		min-height: 80vh;
		background-color: #fafafa;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 3vh 0em;
	}

	.SearchPage_container_form {
		width: 90vw;
		margin: 5vh auto;
		gap: 1em;
		height: 100%;
		display: flex;
		justify-content: space-around;
		align-content: space-around;
		font-family: "Roboto", sans-serif;
		color: #444444;
		font-weight: 400;
		font-size: 18px;
		flex-wrap: wrap;
	}

	.SearchPage_container_form input,
	.SearchPage_container_form select {
		min-width: 25%;
		height: 35px;
		padding: 0.375rem 0.75rem;
		font-size: 12px;
		font-weight: 400;
		line-height: 1.5;
		color: #212529;
		background-color: #fff;
		background-clip: padding-box;
		border: 1px solid #ced4da;
		appearance: none;
		border-radius: 0.375rem;
		transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
	}

	.SearchPage_div_btn {
		width: 100%;
		display: flex;
		justify-content: center;
	}

	.SearchPage_container_form button {
		width: 30%;
		background-color: #3b82f5;
		border: none;
		font-weight: 600;
		padding: 1vh 2vw;
		font-family: "Roboto", sans-serif;
		font-size: 15px;
		text-transform: uppercase;
		align-self: flex-end;
		color: #ffffff;
		border-radius: 5px;
	}

	.SearchPage_divisor {
		width: 50vw;
		border: 0.1px solid #958c8c29;
	}

	.SearchPage_search_results {
		width: 80vw;
		padding: 2vh;
		display: flex;
		/* justify-content: space-around; */
		align-items: center;
		flex-wrap: wrap;
		overflow-y: auto;
	}

	.SearchPage_Fade_In {
		display: flex;
		flex-wrap: wrap;
	}

	.SearchPage_card_result {
		width: 100%;
		min-height: 20vh;
		box-shadow: 0px 4px 10px #958c8c29;
		padding: 10px 20px;
		display: flex;
		flex-direction: row;
		align-items: center;
		align-self: center;
		font-family: "Roboto", sans-serif;
		cursor: pointer;
		border-radius: 5px;
		margin: 2vh 1vw;
		background-color: #fcfcfc;
	}

	.SearchPage_Fade_In_Child {
		max-width: 45%;
		margin: 0vh 1vw;
	}

	.SearchPage_card_result a {
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;
		align-self: center;
	}

	.SearchPage_card_img {
		width: 30%;
		margin: 1vh 2vw;
		box-shadow: 0px 4px 10px #958c8c29;
		border-radius: 5px;
		background-color: #fcfcfc;
	}

	.SearchPage_card_img img {
		width: 100%;
		border-radius: 5px;
	}

	.SearchPage_card_type {
		font-family: "Roboto", sans-serif;
		text-align: left;
	}

	.SearchPage_card_reference {
		font-size: 13px;
		color: #6c6565;
		font-weight: lighter;
	}

	.SearchPage_card_description {
		font-size: 14px;
		color: #6c6565;
		text-overflow: ellipsis;
		overflow: hidden;
		font-weight: lighter;
		white-space: nowrap;
		max-width: 300px;
	}

	/* Exhibition Card */

	.ExhibitionCard_container_image {
		width: 90%;
		margin-bottom: 1em;
		min-height: 30%;
	}

	.ExhibitionCard_container_image img {
		width: 100%;
		border-radius: 5px;
	}

	/* Exhibition Pop up */

	.Exhibition_popup_container {
		width: 100vw;
		/* height: 90vh; */
		position: fixed;
		top: 65%;
		left: 50%;
		transform: translate(-50%, -50%);
		background: rgba(0, 0, 0, 0.7);
		padding: 0;
		border-radius: 10px;
		z-index: 1000;
	}

	.Exhibition_popup_container_inner {
		width: 100vw;
		height: 80%;
		background-color: #ffffff;
		padding: 1em;
	}

	.Exhibition_popup_container_close {
		text-align: end;
	}

	.ExhibitionCard_container_exibhition_card {
		font-family: "Roboto", sans-serif;
		width: 100vw;
		display: flex;
		justify-content: space-between;
		margin: auto;
		flex-wrap: wrap;
	}
	.ExhibitionCard_div_esquerda_exhibition_card {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 0vh 2vw;
	}
	.ExhibitionCard_div_direita_exhibition_card {
		width: 100%;
		border-left: 1px solid #00000010;
		padding: 0vh 2vw;
	}
	.ExhibitionCard_image_exhibition_card {
		width: 90%;
	}
	.ExhibitionCard_descricao_exhibition_card {
		width: 90%;
		max-height: 250px;
		overflow: hidden;
		padding: 10px 20px;
		border-radius: 5px;
		background-color: #00000020;
		font-size: 12px;
		display: flex;
		gap: 10px;
		align-items: center;
		cursor: pointer;
		text-align: justify;
	}
	.ExhibitionCard_observacao_exhibition_card {
		width: 90%;
		padding: 10px 20px;
		border-radius: 5px;
		background-color: #ffffff;
		font-size: 12px;
		gap: 15px;
		align-items: center;
		cursor: pointer;
		box-shadow: 1px 1px 60px #00000005;
		border: 1px solid #00000020;
		margin-top: 2vh;
	}
	.ExhibitionCard_referencia_exhibition_card {
		width: 90%;
		padding: 0.5vh 1vw;
		font-size: 13px;
		margin: 0vh 0vw;
		background-color: #3b82f5;
		color: #ffffff;
		font-weight: bold;
		border-radius: 3px;
	}
	.ExhibitionCard_referencia_exhibition_card span {
		font-weight: bold;
		margin-right: 3px;
	}

	.ExhibitionCard_container_tags {
		width: 90%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap;
		box-shadow: 1px 1px 60px #00000005;
		border: 1px solid #00000020;
		margin-top: 2vh;
		padding: 10px 20px;
		border-radius: 5px;
		background-color: #ffffff;
	}

	.ExhibitionCard_container_tags span {
		font-weight: bold;
		margin-right: 3px;
		font-size: 12px;
		display: flex;
		align-items: center;
	}

	.ExhibitionCard_projetos_exhibition_card {
		width: 90%;
		flex-wrap: wrap;
		box-shadow: 1px 1px 60px #00000005;
		border: 1px solid #00000020;
		margin-top: 2vh;
		padding: 10px 20px;
		display: flex;
		border-radius: 5px;
		background-color: #ffffff;
	}
	.ExhibitionCard_proj_original_exhibition_card {
	}
	.ExhibitionCard_link_exhibition_card {
		width: 90%;
		border-radius: 5px;
		background-color: #00000020;
		padding: 0.5vh 2vw;
		font-size: 12px;
		margin: 1vh 0vw;
		text-align: left;
	}

	.ExhibitionCard_link_exhibition_card span {
		font-weight: bold;
		margin-right: 3px;
	}

	.ExhibitionCard_origem_exhibition_card {
		margin-bottom: 0.5em;
		padding-bottom: 0.5em;
		border-bottom: 0.5px solid #3b82f5;
		font-size: 12px;
	}

	.ExhibitionCard_origem_exhibition_card span {
		font-weight: bold;
		margin-right: 3px;
	}

	.ExhibitionCard_info_exhibition_card {
		width: 90%;
		padding: 0.5vh 2vw;
		font-size: 12px;
		margin: 1vh 0vw;
		box-shadow: 1px 1px 60px #00000005;
		border: 1px solid #00000020;
		border-radius: 5px;
	}

	.ExhibitionCard_info_exhibition_card span {
		font-weight: bold;
		margin-right: 5px;
	}

	.ExhibitionCard_botoes_exhibition_card {
		width: 90%;
		display: flex;
		justify-content: space-around;
		padding: 0.5vh 2vw;
	}

	.ExhibitionCard_botoes_exhibition_card button {
		border: none;
		width: 10vw;
		border-radius: 5px;
		padding: 1vh 2 vw;
		font-weight: bold;
		color: #ffffff;
		background-color: #3b82f5;
	}

	/* RegisterPage */

	.RegisterPage_main_container {
		width: 100vw;
		min-height: 80vh;
		background-color: #fafafa;
		/* padding: 5vh 5vw; */
		text-align: center;
	}

	.RegisterPage_btn_confirm {
		border: none;
		background-color: #008000;
		color: #ffffff;
		padding: 0.5vh 2vw;
		border-radius: 6px;
	}

	.RegisterPage_container_form {
		display: flex;
		justify-content: space-around;
		width: 100%;
		overflow: scroll;
		padding: 2em 1em;
		background-color: #ffffff;
		/* box-shadow: 0px 0px 4px #dcdcdc; */
	}

	.RegisterPage_Input_Image {
		border: 1px dashed #3b82f5;
		border-radius: 5px;
		width: 100%;
		margin: auto;
		height: 35vh;
	}

	.RegisterPage_image_loaded {
		margin: auto;
		max-height: 60%;
	}

	.RegisterPage_container_image {
		width: 47vw;
		min-height: 400px;
		padding-right: 5vw;
		display: flex;
		flex-direction: column;
		align-items: space-around;
		/* justify-content: space-between; */
	}

	.RegisterPage_container_image img {
		max-width: 70%;
		border-radius: 5px;
	}

	.RegisterPage_container_informations {
		width: 47vw;
	}

	.RegisterPage_description {
		width: 100%;
		font-family: "Roboto", sans-serif;
		border-radius: 5px;
		border: none;
		background: #ffffff;
		padding: 15px;
		font-style: italic;
	}

	.RegisterPage_container_tags {
		display: flex;
		flex-wrap: wrap;
		margin-top: 1em;
		padding-top: 5px;
		flex-direction: row;
		max-height: 65px;
		overflow: auto;
		text-align: justify;
	}
	.RegisterPage_container_master_tags {
		font-family: "Roboto", sans-serif;
		border-radius: 5px;
		background: #ffffff;
		color: #b1b1b1;
		padding: 15px;
		font-style: italic;
	}
	.RegisterPage_input_search_style {
		width: 100%;
		border: none;
		border-bottom: 0.5px solid #9fc0f5;
		background-color: transparent;
		font-family: "Roboto", sans-serif;
		color: #b1b1b1;
		font-style: italic;
	}

	.RegisterPage_Selected_Tag {
		background-color: transparent;
		color: #6c6565;
		font-size: 12px;
		padding-left: 1vw;
		border: none;
	}

	.RegisterPage_Sugested_Tag {
		background-color: transparent;
		color: #41a5d7;
		font-size: 12px;
		margin-left: 0px;
		border: none;
	}

	.RegisterPage_container_links {
		display: flex;
		flex-wrap: wrap;
		width: 100%;
		justify-content: space-between;
		padding: 3vh 0vw;
	}

	.RegisterPage_container_links input {
		width: 90%;
		margin: 0.5vh 0vw;
		background-color: #ffffff;
		border-radius: 5px;
		font-size: 15px;
		padding: 0.5vh 2vw;
	}

	.RegisterPage_container_projects {
		width: 100%;
		/* padding: 2vh 3vw; */
		display: flex;
		justify-content: space-around;
		align-items: center;
		background-color: #ffffff;
		/* border: 1px solid #707070;
        border-radius: 6px; */
		font-size: 15px;
	}

	.RegisterPage_container_projects select {
		width: 100%;
		height: 80%;
		font-size: 13px;
		border-radius: 5px;
		box-shadow: 0px 0px 4px #9fc0f5;
		border: none;
		color: #3b82f5;
	}

	.RegisterPage_container_origin {
		margin-top: 1vh;
		width: 100%;
		padding: 0px;
		justify-content: space-between;
		border-radius: 5px;
	}

	.RegisterPage_container_origin select {
		width: 100%;
		font-size: 13px;
		border: none;
		background-color: #ffffff;
		border-bottom: 0.5px solid #9fc0f5;
	}

	.RegisterPage_container_origin textarea {
		width: 100%;
		font-size: 13px;
		border: none;
		background-color: #ffffff;
	}

	.RegisterForm_select {
		width: 100%;
		margin-bottom: 0.5em;
		padding: 0.5em 3em;
		border-radius: 5px;
		color: #212529;
	}

	.RegisterPage_Confirmation_popup_container {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.5);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.RegisterPage_div_btn {
		width: 100%;
		text-align: center;
		margin-bottom: 2vh;
	}

	.RegisterPage_Content_Style {
		background: white;
		padding: 20px;
		border-radius: 8px;
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
		text-align: center;
	}

	.RegisterPage_Content_Style p {
		color: #3b82f5;
		font-size: 18px;
		font-weight: 500;
	}

	.RegisterPage_PopUp_confirm_btn {
		border: none;
		background-color: green;
		color: #ffffff;
		width: 7em;
		border-radius: 5px;
		margin: 0.5em 1em;
	}

	.RegisterPage_PopUp_cancel_btn {
		border: none;
		background-color: red;
		color: #ffffff;
		width: 7em;
		border-radius: 5px;
		margin: 0.5em 1em;
	}

	/* SettingsPage */

	.SettingsPage_main_container {
		width: 100vw;
		min-height: 80vh;
		background-color: #fafafa;
		padding: 5vh 5vw;
		text-align: center;
	}

	.SettingsPage_container_admins {
		box-shadow: 0px 1px 50px #b9b6b640;
		border-radius: 10px;
		padding: 0.5em 5vw;
		min-height: min-content;
		font-family: "Roboto", sans-serif;
		font-size: large;
		font-weight: bold;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		margin: 30px 0px;
	}

	.SettingsPage_admin_line {
		display: flex;
		width: 100%;
		justify-content: space-around;
		margin: 0.5em;
		font-family: "Roboto", sans-serif;
		font-weight: 300;
		font-size: larger;
		color: #707070;
	}

	.SettingsPage_admin_column {
		width: 25%;
		text-align: left;
		font-size: 16px;
		margin: 10px 0;
	}

	.SettingsPage_admin_column button {
		min-width: 45%;
		background-color: transparent;
		text-align: end;
		border: none;
		font-size: 14px;
	}

	#SettingsPage_btn_Administradores {
		width: 12vw;
	}

	/* MyRecordsPage */

	.MyRecordsPage_main_container {
		width: 100vw;
		min-height: 80vh;
		background-color: #fafafa;
		padding: 5vh 5vw;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	/* AboutPage */

	.AboutPage_main_container {
		width: 100vw;
		padding: 3vh 5vw;
		min-height: 83vh;
		background-color: #fafafa;
	}

	.AboutPage_title {
		display: flex;
		margin-bottom: 1.5em;
		justify-content: center;
	}

	.AboutPage_title_separator {
		margin: 0vh 1vw;
		border: 1px solid #6c6565;
	}

	.AboutPage_title_main {
		font-size: 19px;
		color: #6c6565;
		align-items: center;
	}

	.AboutPage_title_main span {
		color: #3b82f5;
		text-transform: uppercase;
		font-weight: 800;
	}

	.AboutPage_title_name {
		font-size: 19px;
		color: #6c6565;
		align-items: center;
	}

	.AboutPage_title_name span {
		color: #f02323;
		text-transform: uppercase;
		font-weight: 800;
	}

	.AboutPage_container_division {
		margin-top: 1.5em;
		display: flex;
	}

	.AboutPage_left {
		width: 40%;
		text-wrap: wrap;
		text-align: justify;
	}

	.AboutPage_left a {
		text-decoration: none;
		color: inherit;
	}

	.AboutPage_section_tipos {
		width: 95%;
		display: flex;
		flex-wrap: wrap;
	}

	.AboutPage_card_tipo {
		width: 100px;
		margin: 1vw;
	}

	.AboutPage_card_tipo a {
		text-decoration: none;
	}

	.AboutPage_card_tipo p {
		font-size: 12px;
		margin-top: 1vh;
		margin-bottom: 0em;
		text-align: center;
	}

	.AboutPage_card_icons {
		min-width: 100%;
		min-height: 90px;
		/* border: 1px solid #cfcdcd; */
		box-shadow: 0px 4px 10px #afc1de;
		border-radius: 7px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		color: #6c6565;
		padding: 1vh;
	}

	.AboutPage_right {
		width: 60%;
		padding: 0vh 3vw;
	}

	.AboutPage_Badges {
		display: flex;
		flex-wrap: wrap;
		justify-content: left;
	}

	.AboutPage_Badges img {
		margin-right: 0.5vw;
		margin-top: 1vh;
		border-radius: 3px;
		/* box-shadow: 0px 4px 10px #afc1de; */
	}

	#AboutPage_Dev_Master_div {
		display: flex;
		padding: 1vh 0em;
	}

	#AboutPage_Dev_Contacts {
		display: flex;
		justify-content: space-around;
		padding: 0em 1vw;
	}

	.AboutPage_Dev_Badges {
		margin-left: 1.5vw;
		display: flex;
		justify-content: left;
		align-items: center;
	}

	.AboutPage_Dev_Badges a {
		margin-right: 1vw;
	}

	/* #AboutPage_Dev_Contacts a{
        margin-top: 1vh;
    } */

	#AboutPage_Dev_Contacts a img {
		border-radius: 3px;
	}

	.PopUpErrorLogin_container {
		width: 40%;
		min-height: 40%;
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background-color: white;
		box-shadow: 0px 0px 10px #6c6565;
		border-radius: 10px;
		z-index: 1000;
		text-align: center;
	}

	.PopUpErrorLogin_main {
		color: #ffffff;
		font-weight: 600;
		padding: 1em;
		font-size: 25px;
		border-radius: 10px 10px 0px 0px;
		background-color: #3b82f5;
	}

	.PopUpErrorLogin_main svg {
		margin-right: 15px;
	}

	.PopUpErrorLogin_text {
		padding: 2em;
	}

	.PopUpErrorLogin_erro {
		color: red;
		margin-top: 1em;
	}

	.PopUpErrorLogin_Dev_Info {
		border-top: 1px solid #6c6565;
		border-bottom: 1px solid #6c6565;

		text-transform: uppercase;
		font-size: 15px;
		margin-top: 0.5em;
	}

	.PopUpErrorLogin_container button {
		margin-top: 1vh;
	}
}

@media (max-width: 600px) {
	.GeneralError_img_container {
		width: 70%;
		margin: 2em auto;
	}

	.GeneralErrorPopUp_Content p {
		text-align: justify;
	}

	/* WelcomePage */

	.container_principal_welcome {
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		align-content: space-around;
	}

	.container_texto_welcome {
		margin-top: 5vh;
		min-width: 80vw;
	}

	.texto_banco {
		font-size: 20px;
		font-weight: 600;
	}

	.texto_recursos {
		font-size: 51px;
		font-weight: 700;
	}

	.texto_name {
		font-size: 17px;
		font-weight: 600;
	}

	.btn_login {
		padding: 0.5vh 5vw;
		font-size: 13px;
		min-width: 30vw;
	}

	.container_video {
		margin-top: 10vh;
		width: 90vw;
	}

	/* HomePage */

	.HomePage_main_container {
		width: 100vw;
		min-height: 80vh;
		padding: 0vh 0vw;
		display: flex;
		justify-content: center;
		flex-direction: column;
	}

	.HomePage_search_container {
		width: 100%;
		min-height: 100px;
		border-radius: 0px;
		margin: 0px;
	}

	.HomePage_middle_text {
		width: 90%;
		margin: 1vh auto;
		text-align: justify;
		color: #878787;
		font-size: 20px;
		font-weight: 500;
	}

	.HomePage_title {
		width: 80%;
		display: flex;
		align-content: center;
		align-self: auto;
		justify-content: center;
		color: #ffffff;
		font-size: 23px;
		text-shadow: 1px 1px 20px #00000095;
		font-weight: 600;
		font-family: "Roboto", sans-serif;
	}

	.HomePage_div_input {
		width: 90%;
		margin: 30px auto;
		display: flex;
	}

	/* SearchPage */

	#notFoundImage {
		width: 50%;
	}

	.SearchPage_container_form {
		width: 90vw;
		margin: 5vh auto;
		gap: 10px;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		align-items: center;
	}

	.SearchPage_container_form input,
	.SearchPage_container_form select {
		width: 100%;
	}

	.SearchPage_search_results {
		width: 100vw;
		padding: 0vh 3vh;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
	}

	.SearchPage_Fade_In_Child {
		max-width: 100%;
		margin: 1vh 0vw;
	}

	.SearchPage_card_result {
		width: 100%;
		min-height: 0px;
		height: 10vh;
		box-shadow: 0px 4px 10px #958c8c29;
		background-color: #fcfcfc;
		display: flex;
		justify-content: flex-start;
		align-self: center;
		font-family: "Roboto", sans-serif;
		cursor: pointer;
		border-radius: 5px;
		margin: 0.5vh 0vw;
		padding: 0px;
	}

	.SearchPage_card_img {
		width: 50%;
		margin-right: 2vh;
		box-shadow: 0px 4px 10px #958c8c29;
		border-radius: 5px;
	}

	.SearchPage_card_type,
	.SearchPage_card_reference {
		width: 100% !important;
		text-align: left;
	}

	.SearchPage_card_description {
		font-size: 14px;
		color: #6c6565;
		text-overflow: ellipsis;
		overflow: hidden;
		font-weight: lighter;
		white-space: nowrap;
		max-width: 200px;
	}

	/* RegisterPage */

	.RegisterPage_container_form {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.RegisterPage_container_image {
		width: 90vw;
		min-height: 50vh;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
	}

	.RegisterPage_container_informations {
		width: 90vw;
		margin-top: 20px;
	}

	.RegisterPage_description {
		padding: 10px;
		margin-bottom: 10px;
	}

	.RegisterPage_container_links {
		display: flex;
		flex-direction: column;
		flex-wrap: wrap;
		width: 100%;
		justify-content: space-around;
		padding: 3vh 0vw;
	}

	.RegisterPage_container_links input {
		width: 100%;
		margin: 1vh auto;
	}

	.RegisterPage_container_projects {
		flex-direction: column;
	}

	.RegisterPage_container_projects select {
		width: 95%;
		font-size: 13px;
		margin: 1vh 0vw;
	}

	.RegisterPage_container_origin {
		flex-direction: column;
	}

	.RegisterPage_container_origin select,
	.RegisterPage_container_origin textarea {
		width: 100%;
		margin-bottom: 1vh;
	}

	/* SettingsPage */

	.SettingsPage_admin_line {
		display: flex;
		flex-direction: column;
		width: 100%;
		justify-content: space-around;
		border-bottom: 1px solid #b1b1b1;
		padding-bottom: 3vh;
	}

	.SettingsPage_admin_column {
		width: 100%;
		text-align: left;
	}

	.SettingsPage_admin_column button {
		width: 50%;
		background-color: transparent;
		text-align: center;
		border: none;
	}

	.MyRecordsPage_main_container {
		padding: 5vh 0vw;
	}

	/* AboutPage */

	.AboutPage_title {
		display: flex;
		margin-bottom: 1.5em;
		justify-content: center;
		flex-direction: column;
		align-items: center;
	}

	.AboutPage_title_separator {
		display: none;
	}

	.AboutPage_container_division {
		margin-top: 1.5em;
		display: flex;
		flex-direction: column-reverse;
		align-items: center;
	}

	.AboutPage_left {
		width: 90%;
		text-wrap: wrap;
		text-align: justify;
	}

	.AboutPage_right {
		width: 110%;
		margin-bottom: 2vh;
	}

	#AboutPage_Dev_Contacts {
		padding: 0vh 3vw;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: left;
	}

	.AboutPage_Dev_Badges {
		margin-left: -2vw;
		margin-top: 1vh;
		display: flex;
		justify-content: left;
		align-items: center;
	}

	.AboutPage_Dev_Badges a {
		margin-right: 1vw;
	}

	.AboutPage_section_tipos {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
	}

	.PopUpErrorLogin_container {
		width: 90%;
		min-height: 40%;
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background-color: white;
		box-shadow: 0px 0px 10px #6c6565;
		border-radius: 10px;
		z-index: 1000;
		text-align: center;
	}

	.PopUpErrorLogin_main {
		color: #ffffff;
		font-weight: 400;
		padding: 0.5em;
		font-size: 20px;
		border-radius: 10px 10px 0px 0px;
		background-color: #3b82f5;
	}

	.PopUpErrorLogin_main svg {
		margin-right: 15px;
	}

	.PopUpErrorLogin_text {
		padding-top: 4vh;
		padding-bottom: 3vh;
		font-size: 15px;
	}

	.PopUpErrorLogin_erro {
		color: red;
		margin-top: 1vh;
		font-size: 12px;
	}

	.PopUpErrorLogin_Dev_Info {
		border-top: 1px solid #6c6565;
		border-bottom: 1px solid #6c6565;
		text-transform: uppercase;
		font-size: 15px;
	}

	.PopUpErrorLogin_container button {
		margin-top: 4vh;
	}

	.waitingFor_text {
		font-size: 25px;
	}
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;;CAEC,2BAA2B;AAC5B;;AAEA;CACC,WAAW;CACX,2CAA2C;AAC5C;;AAEA;CACC;EACC,uBAAuB;CACxB;;CAEA;EACC,yBAAyB;CAC1B;AACD;;AAEA,gBAAgB;AAChB;CACC,YAAY;CACZ,gBAAgB;CAChB,gBAAgB;CAChB,cAAc;CACd,YAAY;CACZ,aAAa;CACb,6BAA6B;CAC7B,yBAAyB;AAC1B;;AAEA;CACC,eAAe;CACf,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,uBAAuB;AACxB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,yBAAyB;CACzB,gBAAgB;AACjB;AACA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,yBAAyB;CACzB,cAAc;CACd,oBAAoB;CACpB,kBAAkB;CAClB,cAAc;CACd,yBAAyB;CACzB,gBAAgB;CAChB,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,WAAW;AACZ;;AAEA,aAAa;;AAEb;CACC,YAAY;CACZ,gBAAgB;CAChB,gBAAgB;CAChB,aAAa;CACb,uBAAuB;CACvB,sBAAsB;CACtB,yBAAyB;AAC1B;;AAEA;CACC,gBAAgB;CAChB,UAAU;CACV,iBAAiB;CACjB,yBAAyB;CACzB,uBAAuB;CACvB,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,iCAAiC;CACjC,eAAe;AAChB;;AAEA;CACC,UAAU;CACV,WAAW;CACX,YAAY;CACZ,aAAa;CACb,qBAAqB;CACrB,mBAAmB;CACnB,gBAAgB;CAChB,uBAAuB;CACvB,cAAc;CACd,eAAe;CACf,mCAAmC;CACnC,gBAAgB;CAChB,iCAAiC;AAClC;;AAEA;CACC,UAAU;CACV,iBAAiB;CACjB,aAAa;CACb,uBAAuB;AACxB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,gCAAgC;CAChC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,YAAY;CACZ,gCAAgC;CAChC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,eAAe;CACf,kBAAkB;CAClB,oBAAoB;CACpB,6BAA6B;CAC7B,2BAA2B;CAC3B,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,yBAAyB;AAC1B;;AAEA;CACC,UAAU;CACV,YAAY;CACZ,aAAa;CACb,gCAAgC;CAChC,mBAAmB;CACnB,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,mBAAmB;CACnB,aAAa;CACb,cAAc;AACf;;AAEA;CACC,eAAe;CACf,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,aAAa;CACb,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,eAAe;AAChB;;AAEA,eAAe;;AAEf;CACC,UAAU;CACV,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,gBAAgB;CAChB,eAAe;CACf,UAAU;CACV,YAAY;AACb;;AAEA;CACC,iBAAiB;CACjB,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,YAAY;CACZ,gBAAgB;CAChB,yBAAyB;CACzB,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,QAAQ;CACR,YAAY;CACZ,aAAa;CACb,6BAA6B;CAC7B,2BAA2B;CAC3B,iCAAiC;CACjC,cAAc;CACd,gBAAgB;CAChB,eAAe;CACf,eAAe;AAChB;;AAEA;;CAEC,UAAU;CACV,YAAY;CACZ,yBAAyB;CACzB,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,cAAc;CACd,sBAAsB;CACtB,4BAA4B;CAC5B,yBAAyB;CACzB,gBAAgB;CAChB,uBAAuB;CACvB,wEAAwE;AACzE;;AAEA;CACC,WAAW;CACX,aAAa;CACb,uBAAuB;AACxB;;AAEA;CACC,UAAU;CACV,yBAAyB;CACzB,YAAY;CACZ,gBAAgB;CAChB,gBAAgB;CAChB,iCAAiC;CACjC,eAAe;CACf,yBAAyB;CACzB,oBAAoB;CACpB,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,6BAA6B;AAC9B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,aAAa;CACb,mCAAmC;CACnC,mBAAmB;CACnB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,kCAAkC;CAClC,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,mBAAmB;CACnB,kBAAkB;CAClB,iCAAiC;CACjC,eAAe;CACf,kBAAkB;CAClB,eAAe;CACf,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,aAAa;CACb,mBAAmB;CACnB,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,UAAU;CACV,eAAe;CACf,kCAAkC;CAClC,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,iCAAiC;CACjC,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,oBAAoB;AACrB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,uBAAuB;CACvB,gBAAgB;CAChB,oBAAoB;CACpB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,iCAAiC;AAClC;;AAEA,oBAAoB;;AAEpB;CACC,UAAU;CACV,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,kBAAkB;AACnB;;AAEA,sBAAsB;;AAEtB;CACC,YAAY;CACZ,iBAAiB;CACjB,eAAe;CACf,QAAQ;CACR,SAAS;CACT,gCAAgC;CAChC,8BAA8B;CAC9B,gBAAgB;CAChB,aAAa;CACb,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;AACA;CACC,UAAU;CACV,WAAW;CACX,yBAAyB;CACzB,mBAAmB;CACnB,wBAAwB;AACzB;;AAEA;CACC,eAAe;CACf,WAAW;CACX,UAAU;AACX;;AAEA;CACC,iCAAiC;CACjC,WAAW;CACX,aAAa;CACb,8BAA8B;CAC9B,YAAY;AACb;AACA;CACC,UAAU;CACV,aAAa;CACb,sBAAsB;CACtB,gBAAgB;AACjB;AACA;CACC,UAAU;CACV,gCAAgC;CAChC,gBAAgB;AACjB;AACA;CACC,UAAU;AACX;AACA;CACC,UAAU;CACV,iBAAiB;CACjB,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;CAClB,2BAA2B;CAC3B,eAAe;CACf,aAAa;CACb,SAAS;CACT,mBAAmB;CACnB,eAAe;CACf,mBAAmB;AACpB;AACA;CACC,UAAU;CACV,kBAAkB;CAClB,kBAAkB;CAClB,yBAAyB;CACzB,eAAe;CACf,SAAS;CACT,mBAAmB;CACnB,eAAe;CACf,kCAAkC;CAClC,2BAA2B;CAC3B,eAAe;AAChB;AACA;CACC,UAAU;CACV,kBAAkB;CAClB,eAAe;CACf,eAAe;CACf,yBAAyB;CACzB,cAAc;CACd,iBAAiB;CACjB,kBAAkB;AACnB;AACA;CACC,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;CACC,UAAU;CACV,aAAa;CACb,2BAA2B;CAC3B,mBAAmB;CACnB,eAAe;CACf,kCAAkC;CAClC,2BAA2B;CAC3B,eAAe;CACf,kBAAkB;CAClB,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,iBAAiB;CACjB,iBAAiB;CACjB,eAAe;CACf,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,UAAU;CACV,eAAe;CACf,kCAAkC;CAClC,2BAA2B;CAC3B,eAAe;CACf,kBAAkB;CAClB,aAAa;CACb,kBAAkB;CAClB,yBAAyB;AAC1B;AACA;AACA;AACA;CACC,UAAU;CACV,kBAAkB;CAClB,2BAA2B;CAC3B,kBAAkB;CAClB,eAAe;CACf,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;CACC,oBAAoB;CACpB,qBAAqB;CACrB,kCAAkC;CAClC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;CACC,UAAU;CACV,kBAAkB;CAClB,eAAe;CACf,eAAe;CACf,kCAAkC;CAClC,2BAA2B;CAC3B,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;CACC,UAAU;CACV,aAAa;CACb,6BAA6B;CAC7B,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,iBAAiB;CACjB,iBAAiB;CACjB,cAAc;CACd,yBAAyB;AAC1B;;AAEA,iBAAiB;;AAEjB;CACC,YAAY;CACZ,gBAAgB;CAChB,yBAAyB;CACzB,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,yBAAyB;CACzB,cAAc;CACd,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,6BAA6B;CAC7B,WAAW;CACX,gBAAgB;CAChB,gBAAgB;CAChB,yBAAyB;CACzB,qCAAqC;CACrC,+BAA+B;AAChC;;AAEA;CACC,0BAA0B;CAC1B,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,iBAAiB;CACjB,kBAAkB;CAClB,aAAa;CACb,sBAAsB;CACtB,yBAAyB;CACzB,oCAAoC;AACrC;;AAEA;CACC,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,iCAAiC;CACjC,kBAAkB;CAClB,qCAAqC;CACrC,oCAAoC;CACpC,YAAY;CACZ,mBAAmB;CACnB,aAAa;CACb,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,aAAa;CACb,eAAe;CACf,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,gBAAgB;CAChB,cAAc;CACd,mBAAmB;AACpB;AACA;CACC,iCAAiC;CACjC,kBAAkB;CAClB,qCAAqC;CACrC,oCAAoC;CACpC,mBAAmB;CACnB,cAAc;CACd,aAAa;CACb,kBAAkB;AACnB;AACA;CACC,WAAW;CACX,YAAY;CACZ,kCAAkC;CAClC,6BAA6B;CAC7B,iCAAiC;CACjC,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,6BAA6B;CAC7B,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,YAAY;AACb;;AAEA;CACC,6BAA6B;CAC7B,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,aAAa;CACb,eAAe;CACf,WAAW;CACX,8BAA8B;CAC9B,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,UAAU;AACX;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,UAAU;CACV,iBAAiB;CACjB,yBAAyB;CACzB,qCAAqC;CACrC,oCAAoC;CACpC,kBAAkB;CAClB,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,0CAA0C;AAC3C;;AAEA;CACC,iDAAiD;CACjD,yBAAyB;CACzB,cAAc;CACd,qCAAqC;AACtC;;AAEA;CACC,WAAW;CACX,sBAAsB;CACtB,aAAa;CACb,6BAA6B;CAC7B,mBAAmB;CACnB,yBAAyB;CACzB;yBACwB;CACxB,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,WAAW;CACX,eAAe;CACf,kBAAkB;CAClB,+BAA+B;CAC/B,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,oCAAoC;CACpC,8BAA8B;CAC9B,kBAAkB;CAClB,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,oBAAoB;CACpB,eAAe;CACf,YAAY;CACZ,yBAAyB;CACzB,kCAAkC;CAClC,aAAa;AACd;;AAEA;CACC,WAAW;CACX,eAAe;CACf,YAAY;CACZ,yBAAyB;CACzB,YAAY;AACb;;AAEA;CACC,WAAW;CACX,oBAAoB;CACpB,oCAAoC;CACpC,kBAAkB;CAClB,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,eAAe;CACf,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;CACZ,8BAA8B;CAC9B,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,iBAAiB;CACjB,aAAa;CACb,kBAAkB;CAClB,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,uBAAuB;CACvB,cAAc;CACd,UAAU;CACV,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,YAAY;CACZ,qBAAqB;CACrB,cAAc;CACd,UAAU;CACV,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;AACA;CACC,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,UAAU;CACV,gBAAgB;CAChB,YAAY;CACZ,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA,iBAAiB;;AAEjB;CACC,YAAY;CACZ,gBAAgB;CAChB,yBAAyB;CACzB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,kCAAkC;CAClC,mBAAmB;CACnB,kBAAkB;CAClB,uBAAuB;CACvB,iCAAiC;CACjC,gBAAgB;CAChB,iBAAiB;CACjB,aAAa;CACb,sBAAsB;CACtB,6BAA6B;CAC7B,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,WAAW;CACX,6BAA6B;CAC7B,aAAa;CACb,iCAAiC;CACjC,gBAAgB;CAChB,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,UAAU;CACV,gBAAgB;CAChB,aAAa;AACd;;AAEA;CACC,UAAU;CACV,aAAa;CACb,mBAAmB;CACnB,6BAA6B;CAC7B,cAAc;CACd,6BAA6B;CAC7B,yBAAyB;CACzB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,uBAAuB;CACvB,aAAa;CACb,6BAA6B;CAC7B,mBAAmB;CACnB,kBAAkB;CAClB,UAAU;CACV,eAAe;CACf,6BAA6B;AAC9B;;AAEA;CACC,UAAU;CACV,qBAAqB;CACrB,aAAa;CACb,6BAA6B;CAC7B,mBAAmB;CACnB,kBAAkB;CAClB,UAAU;CACV,eAAe;CACf,6BAA6B;CAC7B,YAAY;AACb;;AAEA,kBAAkB;;AAElB;CACC,YAAY;CACZ,gBAAgB;CAChB,yBAAyB;CACzB,gBAAgB;CAChB,aAAa;CACb,uBAAuB;CACvB,sBAAsB;CACtB,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA,aAAa;;AAEb;CACC,0BAA0B;CAC1B,kBAAkB;CAClB,WAAW;CACX,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,yBAAyB;CACzB,kBAAkB;CAClB,cAAc;CACd,cAAc;CACd,yBAAyB;CACzB,gBAAgB;CAChB,iCAAiC;CACjC,aAAa;CACb,aAAa;CACb,6BAA6B;CAC7B,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,6BAA6B;CAC7B,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,cAAc;CACd,kBAAkB;CAClB,cAAc;CACd,yBAAyB;CACzB,iCAAiC;CACjC,aAAa;CACb,aAAa;CACb,6BAA6B;CAC7B,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA,cAAc;;AAEd;CACC,YAAY;CACZ,gBAAgB;CAChB,gBAAgB;CAChB,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,oBAAoB;CACpB,uBAAuB;AACxB;;AAEA;CACC,eAAe;CACf,yBAAyB;AAC1B;;AAEA;CACC,eAAe;CACf,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;CACjB,aAAa;CACb,8BAA8B;AAC/B;;AAEA;CACC,UAAU;CACV,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;CACrB,cAAc;AACf;;AAEA;CACC,WAAW;CACX,aAAa;CACb,eAAe;AAChB;;AAEA;CACC,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,+BAA+B;CAC/B,gCAAgC;CAChC,kBAAkB;CAClB,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,mBAAmB;CACnB,cAAc;CACd,YAAY;AACb;;AAEA;CACC,UAAU;CACV,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,eAAe;CACf,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;CACnB,eAAe;CACf,kBAAkB;CAClB,sCAAsC;AACvC;;AAEA;CACC,aAAa;CACb,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,6BAA6B;CAC7B,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,qBAAqB;CACrB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;;GAEG;;AAEH;CACC,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,aAAa;CACb,eAAe;CACf,MAAM;CACN,oCAAoC;CACpC,gBAAgB;CAChB,aAAa;AACd;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,yBAAyB;CACzB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,aAAa;CACb,aAAa;CACb,sBAAsB;CACtB,8BAA8B;CAC9B,yBAAyB;AAC1B;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,cAAc;AACf;;AAEA;;CAEC,UAAU;AACX;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,UAAU;CACV,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,UAAU;CACV,eAAe;CACf,eAAe;CACf,QAAQ;CACR,SAAS;CACT,gCAAgC;CAChC,uBAAuB;CACvB,gCAAgC;CAChC,mBAAmB;CACnB,aAAa;CACb,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,YAAY;CACZ,eAAe;CACf,gCAAgC;CAChC,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,UAAU;CACV,eAAe;AAChB;;AAEA;CACC,6BAA6B;CAC7B,gCAAgC;CAChC,yBAAyB;CACzB,eAAe;AAChB;;AAEA;CACC,yBAAyB;CACzB,cAAc;CACd,yBAAyB;CACzB,kBAAkB;CAClB,kBAAkB;CAClB,+BAA+B;CAC/B,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,aAAa;CACb,eAAe;CACf,OAAO;CACP,SAAS;CACT,8BAA8B;CAC9B,oCAAoC;CACpC,gCAAgC;CAChC,aAAa;CACb,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,yBAAyB;AAC1B;;AAEA,eAAe;;AAEf;CACC;EACC,eAAe;EACf,cAAc;CACf;;CAEA;EACC,UAAU;EACV,gBAAgB;CACjB;;CAEA,gBAAgB;CAChB;EACC,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;CAC1B;;CAEA;EACC,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;CACxB;;CAEA;EACC,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;CACjB;CACA;EACC,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;CAChB;;CAEA;EACC,WAAW;CACZ;;CAEA,aAAa;;CAEb;EACC,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;CAC1B;;CAEA;EACC,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;CACpB;;CAEA;EACC,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;CAChB;;CAEA;EACC,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,mCAAmC;EACnC,gBAAgB;EAChB,iCAAiC;CAClC;;CAEA;EACC,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,uBAAuB;CACxB;;CAEA;EACC,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,gCAAgC;EAChC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;CAClB;;CAEA;EACC,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,6BAA6B;EAC7B,2BAA2B;EAC3B,aAAa;CACd;;CAEA;EACC,qBAAqB;EACrB,yBAAyB;CAC1B;;CAEA;EACC,UAAU;EACV,YAAY;EACZ,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,cAAc;CACf;;CAEA;EACC,eAAe;EACf,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,eAAe;CAChB;;CAEA;EACC,aAAa;EACb,eAAe;CAChB;;CAEA,eAAe;;CAEf;EACC,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;EAChB,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,2BAA2B;EAC3B,iCAAiC;EACjC,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;CAChB;;CAEA;;EAEC,cAAc;EACd,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,wEAAwE;CACzE;;CAEA;EACC,WAAW;EACX,aAAa;EACb,uBAAuB;CACxB;;CAEA;EACC,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,6BAA6B;CAC9B;;CAEA;EACC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,aAAa;EACb,eAAe;CAChB;;CAEA;EACC,WAAW;EACX,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,yBAAyB;CAC1B;;CAEA;EACC,cAAc;EACd,eAAe;CAChB;;CAEA;EACC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;CACnB;;CAEA;EACC,UAAU;EACV,eAAe;EACf,kCAAkC;EAClC,kBAAkB;EAClB,yBAAyB;CAC1B;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,iCAAiC;EACjC,gBAAgB;CACjB;;CAEA;EACC,eAAe;EACf,cAAc;EACd,oBAAoB;CACrB;;CAEA;EACC,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;CACjB;;CAEA,oBAAoB;;CAEpB;EACC,UAAU;EACV,kBAAkB;EAClB,eAAe;CAChB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA,sBAAsB;;CAEtB;EACC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,8BAA8B;EAC9B,UAAU;EACV,mBAAmB;EACnB,aAAa;CACd;;CAEA;EACC,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,YAAY;CACb;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,iCAAiC;EACjC,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,eAAe;CAChB;CACA;EACC,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gBAAgB;CACjB;CACA;EACC,WAAW;EACX,gCAAgC;EAChC,gBAAgB;CACjB;CACA;EACC,UAAU;CACX;CACA;EACC,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,mBAAmB;CACpB;CACA;EACC,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,kCAAkC;EAClC,2BAA2B;EAC3B,eAAe;CAChB;CACA;EACC,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;CACnB;CACA;EACC,iBAAiB;EACjB,iBAAiB;CAClB;;CAEA;EACC,UAAU;EACV,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,kCAAkC;EAClC,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;CAC1B;;CAEA;EACC,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;CACpB;;CAEA;EACC,UAAU;EACV,eAAe;EACf,kCAAkC;EAClC,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;CAC1B;CACA;CACA;CACA;EACC,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,iBAAiB;EACjB,iBAAiB;CAClB;;CAEA;EACC,oBAAoB;EACpB,qBAAqB;EACrB,kCAAkC;EAClC,eAAe;CAChB;;CAEA;EACC,iBAAiB;EACjB,iBAAiB;CAClB;;CAEA;EACC,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kCAAkC;EAClC,2BAA2B;EAC3B,kBAAkB;CACnB;;CAEA;EACC,iBAAiB;EACjB,iBAAiB;CAClB;;CAEA;EACC,UAAU;EACV,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;CACnB;;CAEA;EACC,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;CAC1B;;CAEA,iBAAiB;;CAEjB;EACC,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;CACnB;;CAEA;EACC,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,aAAa;EACb,6BAA6B;EAC7B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,qCAAqC;CACtC;;CAEA;EACC,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;CACb;;CAEA;EACC,YAAY;EACZ,eAAe;CAChB;;CAEA;EACC,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,oCAAoC;CACrC;;CAEA;EACC,cAAc;EACd,kBAAkB;CACnB;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,WAAW;EACX,iCAAiC;EACjC,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,kBAAkB;CACnB;;CAEA;EACC,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;CACpB;CACA;EACC,iCAAiC;EACjC,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;CACnB;CACA;EACC,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,6BAA6B;EAC7B,iCAAiC;EACjC,cAAc;EACd,kBAAkB;CACnB;;CAEA;EACC,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,YAAY;CACb;;CAEA;EACC,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;CACb;;CAEA;EACC,aAAa;EACb,eAAe;EACf,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;CACjB;;CAEA;EACC,UAAU;EACV,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,yBAAyB;EACzB;6BAC2B;EAC3B,eAAe;CAChB;;CAEA;EACC,WAAW;EACX,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,+BAA+B;EAC/B,YAAY;EACZ,cAAc;CACf;;CAEA;EACC,eAAe;EACf,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,kCAAkC;CACnC;;CAEA;EACC,WAAW;EACX,eAAe;EACf,YAAY;EACZ,yBAAyB;CAC1B;;CAEA;EACC,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;CACf;;CAEA;EACC,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;CACxB;;CAEA;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;CACnB;;CAEA;EACC,cAAc;EACd,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,iBAAiB;CAClB;;CAEA;EACC,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,iBAAiB;CAClB;;CAEA,iBAAiB;;CAEjB;EACC,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;CACnB;;CAEA;EACC,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,gBAAgB;CACjB;;CAEA;EACC,aAAa;EACb,WAAW;EACX,6BAA6B;EAC7B,aAAa;EACb,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;CACf;;CAEA;EACC,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,cAAc;CACf;;CAEA;EACC,cAAc;EACd,6BAA6B;EAC7B,eAAe;EACf,YAAY;EACZ,eAAe;CAChB;;CAEA;EACC,WAAW;CACZ;;CAEA,kBAAkB;;CAElB;EACC,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;CACpB;;CAEA,cAAc;;CAEd;EACC,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;CAC1B;;CAEA;EACC,aAAa;EACb,oBAAoB;EACpB,uBAAuB;CACxB;;CAEA;EACC,eAAe;EACf,yBAAyB;CAC1B;;CAEA;EACC,eAAe;EACf,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,yBAAyB;EACzB,gBAAgB;CACjB;;CAEA;EACC,eAAe;EACf,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,yBAAyB;EACzB,gBAAgB;CACjB;;CAEA;EACC,iBAAiB;EACjB,aAAa;CACd;;CAEA;EACC,UAAU;EACV,eAAe;EACf,mBAAmB;CACpB;;CAEA;EACC,qBAAqB;EACrB,cAAc;CACf;;CAEA;EACC,UAAU;EACV,aAAa;EACb,eAAe;CAChB;;CAEA;EACC,YAAY;EACZ,WAAW;CACZ;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,YAAY;CACb;;CAEA;EACC,UAAU;EACV,gBAAgB;CACjB;;CAEA;EACC,aAAa;EACb,eAAe;EACf,qBAAqB;CACtB;;CAEA;EACC,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,sCAAsC;CACvC;;CAEA;EACC,aAAa;EACb,gBAAgB;CACjB;;CAEA;EACC,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;CACjB;;CAEA;EACC,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,mBAAmB;CACpB;;CAEA;EACC,iBAAiB;CAClB;;CAEA;;OAEM;;CAEN;EACC,kBAAkB;CACnB;;CAEA;EACC,UAAU;EACV,eAAe;EACf,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,uBAAuB;EACvB,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;CACnB;;CAEA;EACC,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,yBAAyB;CAC1B;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,YAAY;CACb;;CAEA;EACC,UAAU;EACV,eAAe;CAChB;;CAEA;EACC,6BAA6B;EAC7B,gCAAgC;;EAEhC,yBAAyB;EACzB,eAAe;EACf,iBAAiB;CAClB;;CAEA;EACC,eAAe;CAChB;AACD;;AAEA;CACC;EACC,UAAU;EACV,gBAAgB;CACjB;;CAEA;EACC,mBAAmB;CACpB;;CAEA,gBAAgB;;CAEhB;EACC,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,2BAA2B;CAC5B;;CAEA;EACC,eAAe;EACf,eAAe;CAChB;;CAEA;EACC,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,kBAAkB;EAClB,eAAe;EACf,eAAe;CAChB;;CAEA;EACC,gBAAgB;EAChB,WAAW;CACZ;;CAEA,aAAa;;CAEb;EACC,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;CACvB;;CAEA;EACC,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;CACZ;;CAEA;EACC,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,UAAU;EACV,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,mCAAmC;EACnC,gBAAgB;EAChB,iCAAiC;CAClC;;CAEA;EACC,UAAU;EACV,iBAAiB;EACjB,aAAa;CACd;;CAEA,eAAe;;CAEf;EACC,UAAU;CACX;;CAEA;EACC,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;CACpB;;CAEA;;EAEC,WAAW;CACZ;;CAEA;EACC,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;CAC9B;;CAEA;EACC,eAAe;EACf,eAAe;CAChB;;CAEA;EACC,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kCAAkC;EAClC,yBAAyB;EACzB,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;CACb;;CAEA;EACC,UAAU;EACV,iBAAiB;EACjB,kCAAkC;EAClC,kBAAkB;CACnB;;CAEA;;EAEC,sBAAsB;EACtB,gBAAgB;CACjB;;CAEA;EACC,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;CACjB;;CAEA,iBAAiB;;CAEjB;EACC,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;CACpB;;CAEA;EACC,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;CAC/B;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,aAAa;EACb,mBAAmB;CACpB;;CAEA;EACC,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,6BAA6B;EAC7B,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,UAAU;EACV,eAAe;EACf,eAAe;CAChB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;;EAEC,WAAW;EACX,kBAAkB;CACnB;;CAEA,iBAAiB;;CAEjB;EACC,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;CACpB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;CACb;;CAEA;EACC,gBAAgB;CACjB;;CAEA,cAAc;;CAEd;EACC,aAAa;EACb,oBAAoB;EACpB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;CACpB;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;CACpB;;CAEA;EACC,UAAU;EACV,eAAe;EACf,mBAAmB;CACpB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;CAClB;;CAEA;EACC,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,mBAAmB;CACpB;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,WAAW;EACX,aAAa;EACb,eAAe;CAChB;;CAEA;EACC,UAAU;EACV,eAAe;EACf,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,uBAAuB;EACvB,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;CACnB;;CAEA;EACC,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,yBAAyB;CAC1B;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;CAChB;;CAEA;EACC,UAAU;EACV,eAAe;EACf,eAAe;CAChB;;CAEA;EACC,6BAA6B;EAC7B,gCAAgC;EAChC,yBAAyB;EACzB,eAAe;CAChB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;CAChB;AACD","sourcesContent":["textarea,\ninput {\n\toverflow: hidden !important;\n}\n\n#loader_blue {\n\twidth: 10vw;\n\tanimation: rotate_loader 3s linear infinite;\n}\n\n@keyframes rotate_loader {\n\tfrom {\n\t\ttransform: rotate(0deg);\n\t}\n\n\tto {\n\t\ttransform: rotate(360deg);\n\t}\n}\n\n/* WelcomePage */\n.container_principal_welcome {\n\twidth: 100vw;\n\tmin-height: 83vh;\n\tpadding: 5vw 0vh;\n\tcolor: #6c757d;\n\tmargin: auto;\n\tdisplay: flex;\n\tjustify-content: space-around;\n\tbackground-color: #fafafa;\n}\n\n.container_texto_welcome {\n\tmax-width: 30vw;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tjustify-content: center;\n}\n\n.texto_welcome {\n\tfont-size: 25px;\n\tfont-weight: 500;\n}\n\n.texto_banco {\n\tfont-size: 25px;\n\tfont-weight: 500;\n}\n\n.texto_recursos {\n\tfont-size: 72px;\n\tfont-weight: 700;\n\tcolor: #3b82f5;\n\ttext-transform: uppercase;\n\tline-height: 0.9;\n}\n.texto_name {\n\tfont-size: 25px;\n\tfont-weight: 500;\n}\n\n.texto_name span {\n\tcolor: #f02323;\n\tfont-weight: 700;\n}\n\n.btn_login {\n\tborder: none;\n\tmin-width: 10vw;\n\tbackground-color: #3b82f5;\n\tcolor: #ffffff;\n\tpadding: 0.6vh 1.5vw;\n\tborder-radius: 5px;\n\tmargin-top: 2%;\n\ttext-transform: uppercase;\n\tfont-weight: 500;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tfont-size: 15px;\n}\n\n.container_video {\n\twidth: 60vw;\n}\n\n/* HomePage */\n\n.HomePage_main_container {\n\twidth: 100vw;\n\tmin-height: 80vh;\n\tpadding: 0vh 0vw;\n\tdisplay: flex;\n\tjustify-content: center;\n\tflex-direction: column;\n\tbackground-color: #fafafa;\n}\n\n.HomePage_search_container {\n\tmargin: 4vh auto;\n\twidth: 90%;\n\tmin-height: 120px;\n\tbackground-color: #3b82f5;\n\t/* padding: 5vw 10vh; */\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tborder-radius: 10px;\n}\n\n.HomePage_middle_text {\n\twidth: 100%;\n\ttext-align: center;\n\tcolor: #fafafa;\n\tfont-size: 18px;\n\tfont-weight: 600;\n\tfont-family: \"Roboto\", sans-serif;\n\tmargin-top: 3vh;\n}\n\n.HomePage_title {\n\tpadding: 0;\n\twidth: 100%;\n\theight: 60px;\n\tdisplay: flex;\n\talign-content: center;\n\talign-items: center;\n\talign-self: auto;\n\tjustify-content: center;\n\tcolor: #ffffff;\n\tfont-size: 50px;\n\ttext-shadow: 1px 1px 20px #00000095;\n\tfont-weight: 600;\n\tfont-family: \"Roboto\", sans-serif;\n}\n\n.HomePage_div_input {\n\twidth: 50%;\n\tmargin: 30px auto;\n\tdisplay: flex;\n\tjustify-content: center;\n}\n\n.HomePage_div_input input {\n\twidth: 100%;\n\tborder: none;\n\tborder-radius: 10px 0px 0px 10px;\n\tpadding-left: 30px;\n}\n\n.HomePage_div_input button {\n\twidth: 60px;\n\theight: 150%;\n\tbackground-color: #ffffff;\n\tborder: none;\n\tborder-radius: 0px 10px 10px 0px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 10px 0px;\n}\n\n.HomePage_container_icons {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: wrap;\n\talign-self: center;\n\tjustify-self: center;\n\tjustify-content: space-around;\n\talign-content: space-around;\n\tmargin: 0.5vw;\n}\n\n.HomePage_container_icons a {\n\ttext-decoration: none;\n\tcolor: #6c6565 !important;\n}\n\n.HomePage_card_icons {\n\twidth: 20%;\n\twidth: 100px;\n\theight: 100px;\n\tbox-shadow: 0px 4px 10px #afc1de;\n\tborder-radius: 10px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tmargin: 0.5vw;\n\tcolor: #6c6565;\n}\n\n.HomePage_cardTipo_Tipo {\n\tfont-size: 14px;\n\twidth: 100%;\n\ttext-align: center;\n}\n\n.HomePage_Secton_Tipos {\n\twidth: 90vw;\n\tmargin: 2em auto;\n\tdisplay: flex;\n\tflex-wrap: wrap;\n}\n\n.HomePage_Fade_In {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n}\n\n/* SearchPage */\n\n#notFoundImage {\n\twidth: 20%;\n\tmargin-bottom: 1em;\n}\n\n.SearchPage_NotFound {\n\ttext-align: center;\n\tcolor: #3b82f5;\n\tfont-size: 20px;\n}\n\n.SearchPage_NotFound_Text {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tfont-weight: 400;\n\ttext-wrap: wrap;\n\twidth: 50%;\n\tmargin: auto;\n}\n\n.SearchPage_NotFound_Text p {\n\tmargin-top: 0.5em;\n\tcolor: #dc3545;\n\tfont-size: 16px;\n}\n\n.SearchPage_main_container {\n\twidth: 100vw;\n\tmin-height: 80vh;\n\tbackground-color: #fafafa;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tpadding: 3vh 0em;\n}\n\n.SearchPage_container_form {\n\twidth: 90vw;\n\tmargin: 5vh auto;\n\tgap: 1em;\n\theight: 100%;\n\tdisplay: flex;\n\tjustify-content: space-around;\n\talign-content: space-around;\n\tfont-family: \"Roboto\", sans-serif;\n\tcolor: #444444;\n\tfont-weight: 400;\n\tfont-size: 18px;\n\tflex-wrap: wrap;\n}\n\n.SearchPage_container_form input,\n.SearchPage_container_form select {\n\twidth: 45%;\n\theight: 35px;\n\tpadding: 0.375rem 0.75rem;\n\tfont-size: 12px;\n\tfont-weight: 400;\n\tline-height: 1.5;\n\tcolor: #212529;\n\tbackground-color: #fff;\n\tbackground-clip: padding-box;\n\tborder: 1px solid #ced4da;\n\tappearance: none;\n\tborder-radius: 0.375rem;\n\ttransition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.SearchPage_div_btn {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n}\n\n.SearchPage_container_form button {\n\twidth: 30%;\n\tbackground-color: #3b82f5;\n\tborder: none;\n\tfont-weight: 600;\n\tpadding: 1vh 2vw;\n\tfont-family: \"Roboto\", sans-serif;\n\tfont-size: 15px;\n\ttext-transform: uppercase;\n\talign-self: flex-end;\n\tcolor: #ffffff;\n\tborder-radius: 5px;\n}\n\n.SearchPage_divisor {\n\twidth: 50vw;\n\tborder: 0.1px solid #958c8c29;\n}\n\n.SearchPage_search_results {\n\twidth: 80vw;\n\tpadding: 2vh;\n\tdisplay: flex;\n\t/* justify-content: space-around; */\n\talign-items: center;\n\tflex-wrap: wrap;\n\toverflow-y: auto;\n}\n\n.SearchPage_Fade_In {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n}\n\n.SearchPage_card_result {\n\twidth: 100%;\n\tmin-height: 20vh;\n\tbox-shadow: 0px 4px 10px #958c8c29;\n\tpadding: 10px 20px;\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\talign-self: center;\n\tfont-family: \"Roboto\", sans-serif;\n\tcursor: pointer;\n\tborder-radius: 5px;\n\tmargin: 1vh 1vw;\n\tbackground-color: #fcfcfc;\n}\n\n.SearchPage_Fade_In_Child {\n\tmax-width: 45%;\n\tmargin: 0vh 1vw;\n}\n\n.SearchPage_card_result a {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\talign-self: center;\n}\n\n.SearchPage_card_img {\n\twidth: 20%;\n\tmargin: 1vh 2vw;\n\tbox-shadow: 0px 4px 10px #958c8c29;\n\tborder-radius: 5px;\n\tbackground-color: #fcfcfc;\n}\n\n.SearchPage_card_img img {\n\twidth: 100%;\n\tborder-radius: 5px;\n}\n\n.SearchPage_card_type {\n\tfont-family: \"Roboto\", sans-serif;\n\ttext-align: left;\n}\n\n.SearchPage_card_reference {\n\tfont-size: 13px;\n\tcolor: #6c6565;\n\tfont-weight: lighter;\n}\n\n.SearchPage_card_description {\n\tfont-size: 14px;\n\tcolor: #6c6565;\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n\tfont-weight: lighter;\n\twhite-space: nowrap;\n\tmax-width: 300px;\n}\n\n.SearchPage_actualPage {\n\tcolor: #6c6565;\n\tfont-family: \"Roboto\", sans-serif;\n}\n\n/* Exhibition Card */\n\n.ExhibitionCard_container_image {\n\twidth: 90%;\n\tmargin-bottom: 1em;\n\tmin-height: 30%;\n}\n\n.ExhibitionCard_container_image img {\n\twidth: 100%;\n\tborder-radius: 5px;\n}\n\n/* Exhibition Pop up */\n\n.Exhibition_popup_container {\n\twidth: 100vw;\n\tmin-height: 100vh;\n\tposition: fixed;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\tbackground: rgba(0, 0, 0, 0.7);\n\tpadding: 1em 3em;\n\tz-index: 1000;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n.Exhibition_popup_container_inner {\n\twidth: 90%;\n\theight: 80%;\n\tbackground-color: #ffffff;\n\tborder-radius: 10px;\n\tpadding: 3em 3em 3em 5em;\n}\n\n.Exhibition_popup_container_close {\n\ttext-align: end;\n\theight: 30%;\n\tpadding: 0;\n}\n\n.ExhibitionCard_container_exibhition_card {\n\tfont-family: \"Roboto\", sans-serif;\n\twidth: 80vw;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin: auto;\n}\n.ExhibitionCard_div_esquerda_exhibition_card {\n\twidth: 40%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: 0vh 2vw;\n}\n.ExhibitionCard_div_direita_exhibition_card {\n\twidth: 60%;\n\tborder-left: 1px solid #00000010;\n\tpadding: 0vh 2vw;\n}\n.ExhibitionCard_image_exhibition_card {\n\twidth: 90%;\n}\n.ExhibitionCard_descricao_exhibition_card {\n\twidth: 90%;\n\tmax-height: 250px;\n\toverflow: hidden;\n\tpadding: 10px 20px;\n\tborder-radius: 5px;\n\tbackground-color: #00000020;\n\tfont-size: 12px;\n\tdisplay: flex;\n\tgap: 10px;\n\talign-items: center;\n\tcursor: pointer;\n\ttext-align: justify;\n}\n.ExhibitionCard_observacao_exhibition_card {\n\twidth: 90%;\n\tpadding: 10px 20px;\n\tborder-radius: 5px;\n\tbackground-color: #ffffff;\n\tfont-size: 12px;\n\tgap: 15px;\n\talign-items: center;\n\tcursor: pointer;\n\tbox-shadow: 1px 1px 60px #00000005;\n\tborder: 1px solid #00000020;\n\tmargin-top: 2vh;\n}\n.ExhibitionCard_referencia_exhibition_card {\n\twidth: 90%;\n\tpadding: 0.5vh 1vw;\n\tfont-size: 13px;\n\tmargin: 0vh 0vw;\n\tbackground-color: #3b82f5;\n\tcolor: #ffffff;\n\tfont-weight: bold;\n\tborder-radius: 3px;\n}\n.ExhibitionCard_referencia_exhibition_card span {\n\tfont-weight: bold;\n\tmargin-right: 3px;\n}\n\n.ExhibitionCard_container_tags {\n\twidth: 90%;\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\talign-items: center;\n\tflex-wrap: wrap;\n\tbox-shadow: 1px 1px 60px #00000005;\n\tborder: 1px solid #00000020;\n\tmargin-top: 2vh;\n\tpadding: 10px 20px;\n\tborder-radius: 5px;\n\tbackground-color: #ffffff;\n}\n\n.ExhibitionCard_container_tags span {\n\tfont-weight: bold;\n\tmargin-right: 3px;\n\tfont-size: 12px;\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.ExhibitionCard_projetos_exhibition_card {\n\twidth: 90%;\n\tflex-wrap: wrap;\n\tbox-shadow: 1px 1px 60px #00000005;\n\tborder: 1px solid #00000020;\n\tmargin-top: 2vh;\n\tpadding: 10px 20px;\n\tdisplay: flex;\n\tborder-radius: 5px;\n\tbackground-color: #ffffff;\n}\n.ExhibitionCard_proj_original_exhibition_card {\n}\n.ExhibitionCard_link_exhibition_card {\n\twidth: 90%;\n\tborder-radius: 5px;\n\tbackground-color: #00000020;\n\tpadding: 0.5vh 2vw;\n\tfont-size: 12px;\n\tmargin: 1vh 0vw;\n\ttext-align: left;\n}\n\n.ExhibitionCard_link_exhibition_card span {\n\tfont-weight: bold;\n\tmargin-right: 3px;\n}\n\n.ExhibitionCard_origem_exhibition_card {\n\tmargin-bottom: 0.5em;\n\tpadding-bottom: 0.5em;\n\tborder-bottom: 0.5px solid #3b82f5;\n\tfont-size: 12px;\n}\n\n.ExhibitionCard_origem_exhibition_card span {\n\tfont-weight: bold;\n\tmargin-right: 3px;\n}\n\n.ExhibitionCard_info_exhibition_card {\n\twidth: 90%;\n\tpadding: 0.5vh 2vw;\n\tfont-size: 12px;\n\tmargin: 1vh 0vw;\n\tbox-shadow: 1px 1px 60px #00000005;\n\tborder: 1px solid #00000020;\n\tborder-radius: 5px;\n}\n\n.ExhibitionCard_info_exhibition_card span {\n\tfont-weight: bold;\n\tmargin-right: 5px;\n}\n\n.ExhibitionCard_botoes_exhibition_card {\n\twidth: 90%;\n\tdisplay: flex;\n\tjustify-content: space-around;\n\tpadding: 0.5vh 2vw;\n}\n\n.ExhibitionCard_botoes_exhibition_card button {\n\tborder: none;\n\twidth: 10vw;\n\tborder-radius: 5px;\n\tpadding: 1vh 2 vw;\n\tfont-weight: bold;\n\tcolor: #ffffff;\n\tbackground-color: #3b82f5;\n}\n\n/* RegisterPage */\n\n.RegisterPage_main_container {\n\twidth: 100vw;\n\tmin-height: 80vh;\n\tbackground-color: #ffffff;\n\t/* padding: 5vh 5vw; */\n\ttext-align: center;\n}\n\n.RegisterPage_btn_confirm {\n\tborder: none;\n\tbackground-color: #008000;\n\tcolor: #ffffff;\n\tpadding: 0.5vh 2vw;\n\tborder-radius: 6px;\n}\n\n.RegisterPage_btn_confirm:disabled {\n\tbackground-color: #dcdcdc;\n}\n\n.RegisterPage_container_form {\n\tdisplay: flex;\n\tjustify-content: space-around;\n\twidth: 100%;\n\toverflow: scroll;\n\tpadding: 2em 1em;\n\tbackground-color: #ffffff;\n\t/* box-shadow: 0px 0px 4px #dcdcdc; */\n\tborder-top: 0.5px solid #dcdcdc;\n}\n\n.RegisterPage_Input_Image {\n\tborder: 1px dashed #3b82f5;\n\tborder-radius: 5px;\n\twidth: 100%;\n\tmargin: auto;\n\theight: 35vh;\n}\n\n.RegisterPage_image_loaded {\n\tmargin: auto;\n\tmax-height: 60%;\n}\n\n.RegisterPage_container_image {\n\twidth: 47vw;\n\tmin-height: 400px;\n\tpadding-right: 5vw;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: space-around;\n\t/* justify-content: space-between; */\n}\n\n.RegisterPage_container_image img {\n\tmax-width: 70%;\n\tborder-radius: 5px;\n}\n\n.RegisterPage_container_informations {\n\twidth: 47vw;\n}\n\n.RegisterPage_description {\n\twidth: 100%;\n\tfont-family: \"Roboto\", sans-serif;\n\tborder-radius: 5px;\n\t/* box-shadow: 0px 0px 4px #9fc0f5; */\n\tborder: 1px solid #dcdcdc !important;\n\tborder: none;\n\tbackground: #ffffff;\n\tpadding: 15px;\n\tfont-style: italic;\n\tresize: none;\n}\n\n.RegisterPage_container_tags {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tmargin-top: 1em;\n\tpadding-top: 5px;\n\tflex-direction: row;\n\tmax-height: 65px;\n\toverflow: auto;\n\ttext-align: justify;\n}\n.RegisterPage_container_master_tags {\n\tfont-family: \"Roboto\", sans-serif;\n\tborder-radius: 5px;\n\t/* box-shadow: 0px 0px 4px #9fc0f5; */\n\tborder: 1px solid #dcdcdc !important;\n\tbackground: #ffffff;\n\tcolor: #b1b1b1;\n\tpadding: 15px;\n\tfont-style: italic;\n}\n.RegisterPage_input_search_style {\n\twidth: 100%;\n\tborder: none;\n\tborder-bottom: 0.5px solid #9fc0f5;\n\tbackground-color: transparent;\n\tfont-family: \"Roboto\", sans-serif;\n\tcolor: #b1b1b1;\n\tfont-style: italic;\n}\n\n.RegisterPage_Selected_Tag {\n\tbackground-color: transparent;\n\tcolor: #6c6565;\n\tfont-size: 12px;\n\tpadding-left: 1vw;\n\tborder: none;\n}\n\n.RegisterPage_Sugested_Tag {\n\tbackground-color: transparent;\n\tcolor: #41a5d7;\n\tfont-size: 12px;\n\tmargin-left: 0px;\n\tborder: none;\n}\n\n.RegisterPage_container_links {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\twidth: 100%;\n\tjustify-content: space-between;\n\tpadding: 3vh 0vw;\n}\n\n.RegisterPage_input_wrap {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 50%;\n}\n\n.RegisterPage_input_wrap label {\n\tfont-size: 12px;\n}\n\n.span1 {\n\tfont-weight: 600;\n\tmargin-right: 1em;\n}\n\n.span2 {\n\tfont-weight: 700;\n\tcolor: #ff0000;\n}\n\n.span3 {\n\tcolor: #ff0000;\n}\n\n.RegisterPage_container_links input {\n\twidth: 95%;\n\tmargin: 0.5vh 0vw;\n\tbackground-color: #ffffff;\n\t/* box-shadow: 0px 0px 4px #9fc0f5; */\n\tborder: 1px solid #dcdcdc !important;\n\tborder-radius: 5px;\n\tfont-size: 12px;\n\tpadding: 0.5vh 2vw;\n}\n\n.rightLink {\n\tbox-shadow: 0px 0px 4px #9fc0f5 !important;\n}\n\n.wrongLink {\n\t/* box-shadow: 0px 0px 12px #FF0000 !important; */\n\tbackground-color: #ff0000;\n\tcolor: #ff0000;\n\toutline: 2px solid #ff0000 !important;\n}\n\n.RegisterPage_container_projects {\n\twidth: 100%;\n\t/* padding: 2vh 3vw; */\n\tdisplay: flex;\n\tjustify-content: space-around;\n\talign-items: center;\n\tbackground-color: #ffffff;\n\t/* border: 1px solid #707070;\n    border-radius: 6px; */\n\tfont-size: 15px;\n\tmargin-bottom: 1vh;\n}\n\n.RegisterPage_container_projects select {\n\twidth: 100%;\n\theight: 80%;\n\tfont-size: 13px;\n\tborder-radius: 5px;\n\tbox-shadow: 0px 0px 4px #9fc0f5;\n\tborder: none;\n\tcolor: #3b82f5;\n}\n\n.label_origin {\n\tfont-size: 12px;\n\tfont-weight: 600;\n\tmargin-top: 2vh;\n}\n\n.RegisterPage_container_origin {\n\twidth: 100%;\n\tpadding: 0px;\n\tborder: 1px solid #dcdcdc !important;\n\tjustify-content: space-between;\n\tborder-radius: 5px;\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.RegisterPage_container_origin select {\n\twidth: 100%;\n\talign-self: flex-end;\n\tfont-size: 13px;\n\tborder: none;\n\tbackground-color: #ffffff;\n\tborder-bottom: 0.5px solid #9fc0f5;\n\tpadding: 10px;\n}\n\n.RegisterPage_container_origin textarea {\n\twidth: 100%;\n\tfont-size: 13px;\n\tborder: none;\n\tbackground-color: #ffffff;\n\tresize: none;\n}\n\n.RegisterForm_select {\n\twidth: 100%;\n\tmargin-bottom: 0.5em;\n\tborder: 1px solid #dcdcdc !important;\n\tpadding: 0.5em 3em;\n\tborder-radius: 5px;\n\tcolor: #212529;\n}\n\n.RegisterPage_Confirmation_popup_container {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tbackground: rgba(0, 0, 0, 0.5);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.RegisterPage_div_btn {\n\twidth: 100%;\n\ttext-align: center;\n\tmargin-bottom: 2vh;\n\tbackground-color: #ffffff;\n}\n\n.RegisterPage_Content_Style {\n\tbackground: white;\n\tpadding: 20px;\n\tborder-radius: 8px;\n\tbox-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\n\ttext-align: center;\n}\n\n.RegisterPage_Content_Style p {\n\tcolor: #3b82f5;\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.RegisterPage_PopUp_confirm_btn {\n\tborder: none;\n\tbackground-color: green;\n\tcolor: #ffffff;\n\twidth: 7em;\n\tborder-radius: 5px;\n\tmargin: 0.5em 1em;\n}\n\n.RegisterPage_PopUp_cancel_btn {\n\tborder: none;\n\tbackground-color: red;\n\tcolor: #ffffff;\n\twidth: 7em;\n\tborder-radius: 5px;\n\tmargin: 0.5em 1em;\n}\n\n.RegisterPage_Text1 {\n\tfont-size: 18px;\n\tfont-weight: 600;\n\tcolor: #02c028;\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.RegisterPage_Text2 {\n\tfont-size: 13px;\n\tfont-weight: 600;\n}\n.RegisterPage_Text2 span {\n\tfont-weight: 400;\n\tfont-size: 12px;\n}\n\n.container_exhibition_created {\n\twidth: 90%;\n\tmax-height: 100%;\n\tmargin: auto;\n\tobject-fit: contain;\n\toverflow: hidden;\n}\n\n/* SettingsPage */\n\n.SettingsPage_main_container {\n\twidth: 100vw;\n\tmin-height: 80vh;\n\tbackground-color: #fafafa;\n\tpadding: 5vh 5vw;\n\ttext-align: center;\n}\n\n.SettingsPage_container_admins {\n\tbox-shadow: 0px 1px 50px #b9b6b640;\n\tborder-radius: 10px;\n\tpadding: 0.5em 5vw;\n\tmin-height: min-content;\n\tfont-family: \"Roboto\", sans-serif;\n\tfont-size: large;\n\tfont-weight: bold;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-around;\n\tmargin: 30px 0px;\n}\n\n.SettingsPage_admin_line {\n\tdisplay: flex;\n\twidth: 100%;\n\tjustify-content: space-around;\n\tmargin: 0.5em;\n\tfont-family: \"Roboto\", sans-serif;\n\tfont-weight: 300;\n\tfont-size: larger;\n\tcolor: #707070;\n}\n\n.SettingsPage_admin_column {\n\twidth: 25%;\n\ttext-align: left;\n\tdisplay: flex;\n}\n\n#SettingsPage_btn_Administradores {\n\twidth: 5vw;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-around;\n\tcolor: #241571;\n\tbackground-color: transparent;\n\tborder: 1px solid #241571;\n\tborder-radius: 5px;\n\tmargin: 1em auto;\n}\n\n#SettingsPage_btn_Edit {\n\tcolor: green;\n\tborder: 1px solid green;\n\tdisplay: flex;\n\tjustify-content: space-around;\n\talign-items: center;\n\tborder-radius: 5px;\n\twidth: 5vw;\n\tfont-size: 17px;\n\tbackground-color: transparent;\n}\n\n#SettingsPage_btn_Delete {\n\tcolor: red;\n\tborder: 1px solid red;\n\tdisplay: flex;\n\tjustify-content: space-around;\n\talign-items: center;\n\tborder-radius: 5px;\n\twidth: 5vw;\n\tfont-size: 17px;\n\tbackground-color: transparent;\n\tmargin: auto;\n}\n\n/* MyRecordsPage */\n\n.MyRecordsPage_main_container {\n\twidth: 100vw;\n\tmin-height: 80vh;\n\tbackground-color: #fafafa;\n\tpadding: 5vh 5vw;\n\tdisplay: flex;\n\tjustify-content: center;\n\tflex-direction: column;\n\talign-items: center;\n\ttext-align: center;\n}\n\n/* EditPage */\n\n.EditPage_Input_Image {\n\tborder: 1px dashed #3b82f5;\n\tborder-radius: 5px;\n\twidth: 100%;\n\tmargin: 2em auto;\n\theight: 5vh;\n}\n\n.EditPage_image_loaded {\n\tmargin: auto;\n\tmax-height: 40%;\n}\n\n#btn_formulario {\n\tborder: 1px solid #008000;\n\tborder-radius: 5px;\n\tmin-width: 8em;\n\tcolor: #ffffff;\n\tbackground-color: #008000;\n\tmargin: 1em auto;\n\tbox-shadow: 0px 0.5px 5px #fafafa;\n\tmargin: 0 3em;\n\tdisplay: flex;\n\tjustify-content: space-around;\n\talign-items: center;\n\tfont-weight: 500;\n}\n\n.edit_final_btns {\n\tdisplay: flex;\n\tjustify-content: space-around;\n\talign-items: center;\n\tpadding: 2em 0;\n}\n\n#btn_cancel_edit {\n\tborder: 1px solid #ff0000;\n\tmin-width: 8em;\n\tborder-radius: 5px;\n\tcolor: #ffffff;\n\tbackground-color: #ff0000;\n\tbox-shadow: 0px 0.5px 5px #fafafa;\n\tmargin: 0 3em;\n\tdisplay: flex;\n\tjustify-content: space-around;\n\talign-items: center;\n\tfont-weight: 500;\n}\n\n/* AboutPage */\n\n.AboutPage_main_container {\n\twidth: 100vw;\n\tpadding: 3vh 5vw;\n\tmin-height: 83vh;\n\tbackground-color: #fafafa;\n}\n\n.AboutPage_title {\n\tdisplay: flex;\n\tmargin-bottom: 1.5em;\n\tjustify-content: center;\n}\n\n.AboutPage_title_separator {\n\tmargin: 0vh 1vw;\n\tborder: 1px solid #6c6565;\n}\n\n.AboutPage_title_main {\n\tfont-size: 19px;\n\tcolor: #6c6565;\n\talign-items: center;\n}\n\n.AboutPage_title_main span {\n\tcolor: #3b82f5;\n\ttext-transform: uppercase;\n\tfont-weight: 800;\n}\n\n.AboutPage_title_name {\n\tfont-size: 19px;\n\tcolor: #6c6565;\n\talign-items: center;\n}\n\n.AboutPage_title_name span {\n\tcolor: #f02323;\n\ttext-transform: uppercase;\n\tfont-weight: 800;\n}\n\n.AboutPage_container_division {\n\tmargin-top: 1.5em;\n\tdisplay: flex;\n\tjustify-content: space-between;\n}\n\n.AboutPage_left {\n\twidth: 50%;\n\ttext-wrap: wrap;\n\ttext-align: justify;\n}\n\n.AboutPage_left a {\n\ttext-decoration: none;\n\tcolor: inherit;\n}\n\n.AboutPage_section_tipos {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-wrap: wrap;\n}\n\n.AboutPage_card_tipo {\n\twidth: 100px;\n\tmargin: 1vw;\n}\n\n.AboutPage_card_tipo a {\n\ttext-decoration: none;\n}\n\n.AboutPage_card_tipo p {\n\tfont-size: 12px;\n\tmargin-top: 1vh;\n\tmargin-bottom: 0em;\n\ttext-align: center;\n}\n\n.AboutPage_card_icons {\n\tmin-width: 100%;\n\tmin-height: 90px;\n\t/* border: 1px solid #cfcdcd; */\n\tbox-shadow: 0px 4px 10px #afc1de;\n\tborder-radius: 7px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tcolor: #6c6565;\n\tpadding: 1vh;\n}\n\n.AboutPage_right {\n\twidth: 50%;\n\tpadding: 0vh 3vw;\n}\n\n.AboutPage_Badges {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tjustify-content: left;\n}\n\n.AboutPage_Badges img {\n\tmargin-right: 0.5vw;\n\tmargin-top: 1vh;\n\tborder-radius: 3px;\n\t/* box-shadow: 0px 4px 10px #afc1de; */\n}\n\n#AboutPage_Dev_Master_div {\n\tdisplay: flex;\n\tpadding: 2vh 0em;\n}\n\n#AboutPage_Dev_Contacts {\n\tdisplay: flex;\n\tjustify-content: space-around;\n\tpadding: 0em 1vw;\n}\n\n.AboutPage_Dev_Badges {\n\tmargin-left: 1.5vw;\n\tdisplay: flex;\n\tjustify-content: left;\n\talign-items: center;\n}\n\n.AboutPage_Dev_Badges a {\n\tmargin-right: 1vw;\n}\n\n/* #AboutPage_Dev_Contacts a{\n    margin-top: 1vh;\n} */\n\n#AboutPage_Dev_Contacts a img {\n\tborder-radius: 3px;\n}\n\n.nomeSenai {\n\tcolor: #f02323;\n\ttext-transform: uppercase;\n\tfont-weight: 800;\n}\n\n.Error_PopUp_Container {\n\twidth: 100%;\n\theight: 100vh;\n\tposition: fixed;\n\ttop: 0;\n\tbackground-color: rgba(0, 0, 0, 0.5);\n\tpadding: 2vh 3vw;\n\tz-index: 1000;\n}\n\n.ErrorPopUp_Content {\n\tmargin-top: 4vh;\n\ttext-align: center;\n\tbackground-color: #ffffff;\n\tborder-radius: 10px;\n\tpadding: 3em 2em;\n}\n\n.ErrorPage_Container {\n\twidth: 100%;\n\theight: 100vh;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\tbackground-color: #fafafa;\n}\n\n.GeneralErrorPopUp_Content {\n\tmargin-top: 4vh;\n\ttext-align: center;\n\tpadding: 0 3em;\n}\n\n.ErrorPopUp_Content h5,\n.GeneralErrorPopUp_Content h5 {\n\tcolor: red;\n}\n\n.GeneralErrorPopUp_Content p {\n\tcolor: #3b82f5;\n}\n\n.GeneralError_img_container {\n\twidth: 20%;\n\tmargin: 2em auto;\n}\n\n.ErrorPopUp_Content p {\n\tcolor: #666666;\n\tfont-size: 13px;\n}\n\n.NotFound_Container {\n\tmin-height: 80vh;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.RedirectInitialPage {\n\tfont-size: 15px;\n\tmargin-top: 1em;\n}\n\n.PopUpErrorLogin_container {\n\twidth: 50%;\n\tmin-height: 30%;\n\tposition: fixed;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\tbackground-color: white;\n\tbox-shadow: 0px 0px 10px #6c6565;\n\tborder-radius: 10px;\n\tz-index: 1000;\n\ttext-align: center;\n\tpadding-bottom: 2em;\n}\n\n.PopUpErrorLogin_main {\n\tcolor: #ffffff;\n\tfont-weight: 600;\n\tpadding: 1em;\n\tfont-size: 25px;\n\tborder-radius: 10px 10px 0px 0px;\n\tbackground-color: #3b82f5;\n}\n\n.PopUpErrorLogin_main svg {\n\tmargin-right: 15px;\n}\n\n.PopUpErrorLogin_text {\n\tpadding-top: 4vh;\n\tpadding-bottom: 3vh;\n}\n\n.PopUpErrorLogin_erro {\n\tcolor: red;\n\tmargin-top: 1vh;\n}\n\n.PopUpErrorLogin_Dev_Info {\n\tborder-top: 1px solid #6c6565;\n\tborder-bottom: 1px solid #6c6565;\n\ttext-transform: uppercase;\n\tfont-size: 15px;\n}\n\n.PopUpErrorLogin_container button {\n\tbackground-color: #ffffff;\n\tcolor: #008f39;\n\tborder: 1px solid #008f39;\n\tborder-radius: 5px;\n\tpadding: 0.5vh 2vw;\n\tbox-shadow: 0px 0px 5px #6c6565;\n\tmargin-top: 2vh;\n}\n\n.waitingFor {\n\twidth: 100%;\n\theight: 100vh;\n\tposition: fixed;\n\ttop: 0%;\n\tleft: 50%;\n\ttransform: translate(-50%, 0%);\n\tbackground-color: rgba(0, 0, 0, 0.5);\n\tbox-shadow: 0px 0px 10px #6c6565;\n\tz-index: 1001;\n\talign-items: center;\n\tpadding-top: 30vh;\n}\n\n.waitingFor_text {\n\ttext-align: center;\n\twidth: 100%;\n\tcolor: #ffffff;\n\tfont-size: 60px;\n\tfont-weight: 600;\n\ttext-transform: uppercase;\n}\n\n/* Responsive */\n\n@media (max-width: 1400px) {\n\t.menu-options a {\n\t\tfont-size: 13px;\n\t\tpadding: 0 1vw;\n\t}\n\n\t.GeneralError_img_container {\n\t\twidth: 40%;\n\t\tmargin: 2em auto;\n\t}\n\n\t/* WelcomePage */\n\t.container_principal_welcome {\n\t\twidth: 100vw;\n\t\tmin-height: 83vh;\n\t\tpadding: 5vw 0vh;\n\t\tcolor: #6c757d;\n\t\tmargin: auto;\n\t\tdisplay: flex;\n\t\tjustify-content: space-around;\n\t\tbackground-color: #fafafa;\n\t}\n\n\t.container_texto_welcome {\n\t\tmax-width: 30vw;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: flex-start;\n\t\tjustify-content: center;\n\t}\n\n\t.texto_welcome {\n\t\tfont-size: 25px;\n\t\tfont-weight: 500;\n\t}\n\n\t.texto_banco {\n\t\tfont-size: 25px;\n\t\tfont-weight: 500;\n\t}\n\n\t.texto_recursos {\n\t\tfont-size: 72px;\n\t\tfont-weight: 700;\n\t\tcolor: #3b82f5;\n\t\ttext-transform: uppercase;\n\t\tline-height: 0.9;\n\t}\n\t.texto_name {\n\t\tfont-size: 25px;\n\t\tfont-weight: 500;\n\t}\n\n\t.texto_name span {\n\t\tcolor: #f02323;\n\t\tfont-weight: 700;\n\t}\n\n\t.btn_login {\n\t\tborder: none;\n\t\tmin-width: 10vw;\n\t\tbackground-color: #3b82f5;\n\t\tcolor: #ffffff;\n\t\tpadding: 0.6vh 1.5vw;\n\t\tborder-radius: 5px;\n\t\tmargin-top: 2%;\n\t\ttext-transform: uppercase;\n\t\tfont-weight: 500;\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tfont-size: 15px;\n\t}\n\n\t.container_video {\n\t\twidth: 60vw;\n\t}\n\n\t/* HomePage */\n\n\t.HomePage_main_container {\n\t\twidth: 100vw;\n\t\tmin-height: 80vh;\n\t\tpadding: 0vh 0vw;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\tflex-direction: column;\n\t\tbackground-color: #fafafa;\n\t}\n\n\t.HomePage_search_container {\n\t\tmargin: 4vh auto;\n\t\twidth: 90%;\n\t\tmin-height: 120px;\n\t\tbackground-color: #3b82f5;\n\t\t/* padding: 5vw 10vh; */\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tborder-radius: 10px;\n\t}\n\n\t.HomePage_middle_text {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t\tcolor: #fafafa;\n\t\tfont-size: 18px;\n\t\tfont-weight: 600;\n\t\tfont-family: \"Roboto\", sans-serif;\n\t\tmargin-top: 3vh;\n\t}\n\n\t.HomePage_title {\n\t\tpadding: 0;\n\t\twidth: 100%;\n\t\theight: 60px;\n\t\tdisplay: flex;\n\t\talign-content: center;\n\t\talign-items: center;\n\t\talign-self: auto;\n\t\tjustify-content: center;\n\t\tcolor: #ffffff;\n\t\tfont-size: 50px;\n\t\ttext-shadow: 1px 1px 20px #00000095;\n\t\tfont-weight: 600;\n\t\tfont-family: \"Roboto\", sans-serif;\n\t}\n\n\t.HomePage_div_input {\n\t\twidth: 50%;\n\t\tmargin: 30px auto;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t}\n\n\t.HomePage_div_input input {\n\t\twidth: 100%;\n\t\tborder: none;\n\t\tborder-radius: 10px 0px 0px 10px;\n\t\tpadding-left: 30px;\n\t}\n\n\t.HomePage_div_input button {\n\t\twidth: 60px;\n\t\theight: 150%;\n\t\tbackground-color: #ffffff;\n\t\tborder: none;\n\t\tborder-radius: 0px 10px 10px 0px;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tpadding: 10px 0px;\n\t}\n\n\t.HomePage_container_icons {\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\tflex-wrap: wrap;\n\t\talign-self: center;\n\t\tjustify-self: center;\n\t\tjustify-content: space-around;\n\t\talign-content: space-around;\n\t\tmargin: 0.5vw;\n\t}\n\n\t.HomePage_container_icons a {\n\t\ttext-decoration: none;\n\t\tcolor: #6c6565 !important;\n\t}\n\n\t.HomePage_card_icons {\n\t\twidth: 20%;\n\t\twidth: 100px;\n\t\theight: 100px;\n\t\tbox-shadow: 0px 4px 10px #afc1de;\n\t\tborder-radius: 10px;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tmargin: 0.5vw;\n\t\tcolor: #6c6565;\n\t}\n\n\t.HomePage_cardTipo_Tipo {\n\t\tfont-size: 14px;\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.HomePage_Secton_Tipos {\n\t\twidth: 90vw;\n\t\tmargin: 2em auto;\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t}\n\n\t.HomePage_Fade_In {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t}\n\n\t/* SearchPage */\n\n\t.SearchPage_main_container {\n\t\twidth: 100vw;\n\t\tmin-height: 80vh;\n\t\tbackground-color: #fafafa;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tpadding: 3vh 0em;\n\t}\n\n\t.SearchPage_container_form {\n\t\twidth: 90vw;\n\t\tmargin: 5vh auto;\n\t\tgap: 1em;\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: space-around;\n\t\talign-content: space-around;\n\t\tfont-family: \"Roboto\", sans-serif;\n\t\tcolor: #444444;\n\t\tfont-weight: 400;\n\t\tfont-size: 18px;\n\t\tflex-wrap: wrap;\n\t}\n\n\t.SearchPage_container_form input,\n\t.SearchPage_container_form select {\n\t\tmin-width: 25%;\n\t\theight: 35px;\n\t\tpadding: 0.375rem 0.75rem;\n\t\tfont-size: 12px;\n\t\tfont-weight: 400;\n\t\tline-height: 1.5;\n\t\tcolor: #212529;\n\t\tbackground-color: #fff;\n\t\tbackground-clip: padding-box;\n\t\tborder: 1px solid #ced4da;\n\t\tappearance: none;\n\t\tborder-radius: 0.375rem;\n\t\ttransition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n\t}\n\n\t.SearchPage_div_btn {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t}\n\n\t.SearchPage_container_form button {\n\t\twidth: 30%;\n\t\tbackground-color: #3b82f5;\n\t\tborder: none;\n\t\tfont-weight: 600;\n\t\tpadding: 1vh 2vw;\n\t\tfont-family: \"Roboto\", sans-serif;\n\t\tfont-size: 15px;\n\t\ttext-transform: uppercase;\n\t\talign-self: flex-end;\n\t\tcolor: #ffffff;\n\t\tborder-radius: 5px;\n\t}\n\n\t.SearchPage_divisor {\n\t\twidth: 50vw;\n\t\tborder: 0.1px solid #958c8c29;\n\t}\n\n\t.SearchPage_search_results {\n\t\twidth: 80vw;\n\t\tpadding: 2vh;\n\t\tdisplay: flex;\n\t\t/* justify-content: space-around; */\n\t\talign-items: center;\n\t\tflex-wrap: wrap;\n\t\toverflow-y: auto;\n\t}\n\n\t.SearchPage_Fade_In {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t}\n\n\t.SearchPage_card_result {\n\t\twidth: 100%;\n\t\tmin-height: 20vh;\n\t\tbox-shadow: 0px 4px 10px #958c8c29;\n\t\tpadding: 10px 20px;\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\talign-items: center;\n\t\talign-self: center;\n\t\tfont-family: \"Roboto\", sans-serif;\n\t\tcursor: pointer;\n\t\tborder-radius: 5px;\n\t\tmargin: 2vh 1vw;\n\t\tbackground-color: #fcfcfc;\n\t}\n\n\t.SearchPage_Fade_In_Child {\n\t\tmax-width: 45%;\n\t\tmargin: 0vh 1vw;\n\t}\n\n\t.SearchPage_card_result a {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\talign-items: center;\n\t\talign-self: center;\n\t}\n\n\t.SearchPage_card_img {\n\t\twidth: 30%;\n\t\tmargin: 1vh 2vw;\n\t\tbox-shadow: 0px 4px 10px #958c8c29;\n\t\tborder-radius: 5px;\n\t\tbackground-color: #fcfcfc;\n\t}\n\n\t.SearchPage_card_img img {\n\t\twidth: 100%;\n\t\tborder-radius: 5px;\n\t}\n\n\t.SearchPage_card_type {\n\t\tfont-family: \"Roboto\", sans-serif;\n\t\ttext-align: left;\n\t}\n\n\t.SearchPage_card_reference {\n\t\tfont-size: 13px;\n\t\tcolor: #6c6565;\n\t\tfont-weight: lighter;\n\t}\n\n\t.SearchPage_card_description {\n\t\tfont-size: 14px;\n\t\tcolor: #6c6565;\n\t\ttext-overflow: ellipsis;\n\t\toverflow: hidden;\n\t\tfont-weight: lighter;\n\t\twhite-space: nowrap;\n\t\tmax-width: 300px;\n\t}\n\n\t/* Exhibition Card */\n\n\t.ExhibitionCard_container_image {\n\t\twidth: 90%;\n\t\tmargin-bottom: 1em;\n\t\tmin-height: 30%;\n\t}\n\n\t.ExhibitionCard_container_image img {\n\t\twidth: 100%;\n\t\tborder-radius: 5px;\n\t}\n\n\t/* Exhibition Pop up */\n\n\t.Exhibition_popup_container {\n\t\twidth: 100vw;\n\t\t/* height: 90vh; */\n\t\tposition: fixed;\n\t\ttop: 65%;\n\t\tleft: 50%;\n\t\ttransform: translate(-50%, -50%);\n\t\tbackground: rgba(0, 0, 0, 0.7);\n\t\tpadding: 0;\n\t\tborder-radius: 10px;\n\t\tz-index: 1000;\n\t}\n\n\t.Exhibition_popup_container_inner {\n\t\twidth: 100vw;\n\t\theight: 80%;\n\t\tbackground-color: #ffffff;\n\t\tpadding: 1em;\n\t}\n\n\t.Exhibition_popup_container_close {\n\t\ttext-align: end;\n\t}\n\n\t.ExhibitionCard_container_exibhition_card {\n\t\tfont-family: \"Roboto\", sans-serif;\n\t\twidth: 100vw;\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tmargin: auto;\n\t\tflex-wrap: wrap;\n\t}\n\t.ExhibitionCard_div_esquerda_exhibition_card {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tpadding: 0vh 2vw;\n\t}\n\t.ExhibitionCard_div_direita_exhibition_card {\n\t\twidth: 100%;\n\t\tborder-left: 1px solid #00000010;\n\t\tpadding: 0vh 2vw;\n\t}\n\t.ExhibitionCard_image_exhibition_card {\n\t\twidth: 90%;\n\t}\n\t.ExhibitionCard_descricao_exhibition_card {\n\t\twidth: 90%;\n\t\tmax-height: 250px;\n\t\toverflow: hidden;\n\t\tpadding: 10px 20px;\n\t\tborder-radius: 5px;\n\t\tbackground-color: #00000020;\n\t\tfont-size: 12px;\n\t\tdisplay: flex;\n\t\tgap: 10px;\n\t\talign-items: center;\n\t\tcursor: pointer;\n\t\ttext-align: justify;\n\t}\n\t.ExhibitionCard_observacao_exhibition_card {\n\t\twidth: 90%;\n\t\tpadding: 10px 20px;\n\t\tborder-radius: 5px;\n\t\tbackground-color: #ffffff;\n\t\tfont-size: 12px;\n\t\tgap: 15px;\n\t\talign-items: center;\n\t\tcursor: pointer;\n\t\tbox-shadow: 1px 1px 60px #00000005;\n\t\tborder: 1px solid #00000020;\n\t\tmargin-top: 2vh;\n\t}\n\t.ExhibitionCard_referencia_exhibition_card {\n\t\twidth: 90%;\n\t\tpadding: 0.5vh 1vw;\n\t\tfont-size: 13px;\n\t\tmargin: 0vh 0vw;\n\t\tbackground-color: #3b82f5;\n\t\tcolor: #ffffff;\n\t\tfont-weight: bold;\n\t\tborder-radius: 3px;\n\t}\n\t.ExhibitionCard_referencia_exhibition_card span {\n\t\tfont-weight: bold;\n\t\tmargin-right: 3px;\n\t}\n\n\t.ExhibitionCard_container_tags {\n\t\twidth: 90%;\n\t\tdisplay: flex;\n\t\tjustify-content: flex-start;\n\t\talign-items: center;\n\t\tflex-wrap: wrap;\n\t\tbox-shadow: 1px 1px 60px #00000005;\n\t\tborder: 1px solid #00000020;\n\t\tmargin-top: 2vh;\n\t\tpadding: 10px 20px;\n\t\tborder-radius: 5px;\n\t\tbackground-color: #ffffff;\n\t}\n\n\t.ExhibitionCard_container_tags span {\n\t\tfont-weight: bold;\n\t\tmargin-right: 3px;\n\t\tfont-size: 12px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t}\n\n\t.ExhibitionCard_projetos_exhibition_card {\n\t\twidth: 90%;\n\t\tflex-wrap: wrap;\n\t\tbox-shadow: 1px 1px 60px #00000005;\n\t\tborder: 1px solid #00000020;\n\t\tmargin-top: 2vh;\n\t\tpadding: 10px 20px;\n\t\tdisplay: flex;\n\t\tborder-radius: 5px;\n\t\tbackground-color: #ffffff;\n\t}\n\t.ExhibitionCard_proj_original_exhibition_card {\n\t}\n\t.ExhibitionCard_link_exhibition_card {\n\t\twidth: 90%;\n\t\tborder-radius: 5px;\n\t\tbackground-color: #00000020;\n\t\tpadding: 0.5vh 2vw;\n\t\tfont-size: 12px;\n\t\tmargin: 1vh 0vw;\n\t\ttext-align: left;\n\t}\n\n\t.ExhibitionCard_link_exhibition_card span {\n\t\tfont-weight: bold;\n\t\tmargin-right: 3px;\n\t}\n\n\t.ExhibitionCard_origem_exhibition_card {\n\t\tmargin-bottom: 0.5em;\n\t\tpadding-bottom: 0.5em;\n\t\tborder-bottom: 0.5px solid #3b82f5;\n\t\tfont-size: 12px;\n\t}\n\n\t.ExhibitionCard_origem_exhibition_card span {\n\t\tfont-weight: bold;\n\t\tmargin-right: 3px;\n\t}\n\n\t.ExhibitionCard_info_exhibition_card {\n\t\twidth: 90%;\n\t\tpadding: 0.5vh 2vw;\n\t\tfont-size: 12px;\n\t\tmargin: 1vh 0vw;\n\t\tbox-shadow: 1px 1px 60px #00000005;\n\t\tborder: 1px solid #00000020;\n\t\tborder-radius: 5px;\n\t}\n\n\t.ExhibitionCard_info_exhibition_card span {\n\t\tfont-weight: bold;\n\t\tmargin-right: 5px;\n\t}\n\n\t.ExhibitionCard_botoes_exhibition_card {\n\t\twidth: 90%;\n\t\tdisplay: flex;\n\t\tjustify-content: space-around;\n\t\tpadding: 0.5vh 2vw;\n\t}\n\n\t.ExhibitionCard_botoes_exhibition_card button {\n\t\tborder: none;\n\t\twidth: 10vw;\n\t\tborder-radius: 5px;\n\t\tpadding: 1vh 2 vw;\n\t\tfont-weight: bold;\n\t\tcolor: #ffffff;\n\t\tbackground-color: #3b82f5;\n\t}\n\n\t/* RegisterPage */\n\n\t.RegisterPage_main_container {\n\t\twidth: 100vw;\n\t\tmin-height: 80vh;\n\t\tbackground-color: #fafafa;\n\t\t/* padding: 5vh 5vw; */\n\t\ttext-align: center;\n\t}\n\n\t.RegisterPage_btn_confirm {\n\t\tborder: none;\n\t\tbackground-color: #008000;\n\t\tcolor: #ffffff;\n\t\tpadding: 0.5vh 2vw;\n\t\tborder-radius: 6px;\n\t}\n\n\t.RegisterPage_container_form {\n\t\tdisplay: flex;\n\t\tjustify-content: space-around;\n\t\twidth: 100%;\n\t\toverflow: scroll;\n\t\tpadding: 2em 1em;\n\t\tbackground-color: #ffffff;\n\t\t/* box-shadow: 0px 0px 4px #dcdcdc; */\n\t}\n\n\t.RegisterPage_Input_Image {\n\t\tborder: 1px dashed #3b82f5;\n\t\tborder-radius: 5px;\n\t\twidth: 100%;\n\t\tmargin: auto;\n\t\theight: 35vh;\n\t}\n\n\t.RegisterPage_image_loaded {\n\t\tmargin: auto;\n\t\tmax-height: 60%;\n\t}\n\n\t.RegisterPage_container_image {\n\t\twidth: 47vw;\n\t\tmin-height: 400px;\n\t\tpadding-right: 5vw;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: space-around;\n\t\t/* justify-content: space-between; */\n\t}\n\n\t.RegisterPage_container_image img {\n\t\tmax-width: 70%;\n\t\tborder-radius: 5px;\n\t}\n\n\t.RegisterPage_container_informations {\n\t\twidth: 47vw;\n\t}\n\n\t.RegisterPage_description {\n\t\twidth: 100%;\n\t\tfont-family: \"Roboto\", sans-serif;\n\t\tborder-radius: 5px;\n\t\tborder: none;\n\t\tbackground: #ffffff;\n\t\tpadding: 15px;\n\t\tfont-style: italic;\n\t}\n\n\t.RegisterPage_container_tags {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tmargin-top: 1em;\n\t\tpadding-top: 5px;\n\t\tflex-direction: row;\n\t\tmax-height: 65px;\n\t\toverflow: auto;\n\t\ttext-align: justify;\n\t}\n\t.RegisterPage_container_master_tags {\n\t\tfont-family: \"Roboto\", sans-serif;\n\t\tborder-radius: 5px;\n\t\tbackground: #ffffff;\n\t\tcolor: #b1b1b1;\n\t\tpadding: 15px;\n\t\tfont-style: italic;\n\t}\n\t.RegisterPage_input_search_style {\n\t\twidth: 100%;\n\t\tborder: none;\n\t\tborder-bottom: 0.5px solid #9fc0f5;\n\t\tbackground-color: transparent;\n\t\tfont-family: \"Roboto\", sans-serif;\n\t\tcolor: #b1b1b1;\n\t\tfont-style: italic;\n\t}\n\n\t.RegisterPage_Selected_Tag {\n\t\tbackground-color: transparent;\n\t\tcolor: #6c6565;\n\t\tfont-size: 12px;\n\t\tpadding-left: 1vw;\n\t\tborder: none;\n\t}\n\n\t.RegisterPage_Sugested_Tag {\n\t\tbackground-color: transparent;\n\t\tcolor: #41a5d7;\n\t\tfont-size: 12px;\n\t\tmargin-left: 0px;\n\t\tborder: none;\n\t}\n\n\t.RegisterPage_container_links {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\twidth: 100%;\n\t\tjustify-content: space-between;\n\t\tpadding: 3vh 0vw;\n\t}\n\n\t.RegisterPage_container_links input {\n\t\twidth: 90%;\n\t\tmargin: 0.5vh 0vw;\n\t\tbackground-color: #ffffff;\n\t\tborder-radius: 5px;\n\t\tfont-size: 15px;\n\t\tpadding: 0.5vh 2vw;\n\t}\n\n\t.RegisterPage_container_projects {\n\t\twidth: 100%;\n\t\t/* padding: 2vh 3vw; */\n\t\tdisplay: flex;\n\t\tjustify-content: space-around;\n\t\talign-items: center;\n\t\tbackground-color: #ffffff;\n\t\t/* border: 1px solid #707070;\n        border-radius: 6px; */\n\t\tfont-size: 15px;\n\t}\n\n\t.RegisterPage_container_projects select {\n\t\twidth: 100%;\n\t\theight: 80%;\n\t\tfont-size: 13px;\n\t\tborder-radius: 5px;\n\t\tbox-shadow: 0px 0px 4px #9fc0f5;\n\t\tborder: none;\n\t\tcolor: #3b82f5;\n\t}\n\n\t.RegisterPage_container_origin {\n\t\tmargin-top: 1vh;\n\t\twidth: 100%;\n\t\tpadding: 0px;\n\t\tjustify-content: space-between;\n\t\tborder-radius: 5px;\n\t}\n\n\t.RegisterPage_container_origin select {\n\t\twidth: 100%;\n\t\tfont-size: 13px;\n\t\tborder: none;\n\t\tbackground-color: #ffffff;\n\t\tborder-bottom: 0.5px solid #9fc0f5;\n\t}\n\n\t.RegisterPage_container_origin textarea {\n\t\twidth: 100%;\n\t\tfont-size: 13px;\n\t\tborder: none;\n\t\tbackground-color: #ffffff;\n\t}\n\n\t.RegisterForm_select {\n\t\twidth: 100%;\n\t\tmargin-bottom: 0.5em;\n\t\tpadding: 0.5em 3em;\n\t\tborder-radius: 5px;\n\t\tcolor: #212529;\n\t}\n\n\t.RegisterPage_Confirmation_popup_container {\n\t\tposition: fixed;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tbackground: rgba(0, 0, 0, 0.5);\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t}\n\n\t.RegisterPage_div_btn {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t\tmargin-bottom: 2vh;\n\t}\n\n\t.RegisterPage_Content_Style {\n\t\tbackground: white;\n\t\tpadding: 20px;\n\t\tborder-radius: 8px;\n\t\tbox-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\n\t\ttext-align: center;\n\t}\n\n\t.RegisterPage_Content_Style p {\n\t\tcolor: #3b82f5;\n\t\tfont-size: 18px;\n\t\tfont-weight: 500;\n\t}\n\n\t.RegisterPage_PopUp_confirm_btn {\n\t\tborder: none;\n\t\tbackground-color: green;\n\t\tcolor: #ffffff;\n\t\twidth: 7em;\n\t\tborder-radius: 5px;\n\t\tmargin: 0.5em 1em;\n\t}\n\n\t.RegisterPage_PopUp_cancel_btn {\n\t\tborder: none;\n\t\tbackground-color: red;\n\t\tcolor: #ffffff;\n\t\twidth: 7em;\n\t\tborder-radius: 5px;\n\t\tmargin: 0.5em 1em;\n\t}\n\n\t/* SettingsPage */\n\n\t.SettingsPage_main_container {\n\t\twidth: 100vw;\n\t\tmin-height: 80vh;\n\t\tbackground-color: #fafafa;\n\t\tpadding: 5vh 5vw;\n\t\ttext-align: center;\n\t}\n\n\t.SettingsPage_container_admins {\n\t\tbox-shadow: 0px 1px 50px #b9b6b640;\n\t\tborder-radius: 10px;\n\t\tpadding: 0.5em 5vw;\n\t\tmin-height: min-content;\n\t\tfont-family: \"Roboto\", sans-serif;\n\t\tfont-size: large;\n\t\tfont-weight: bold;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: space-around;\n\t\tmargin: 30px 0px;\n\t}\n\n\t.SettingsPage_admin_line {\n\t\tdisplay: flex;\n\t\twidth: 100%;\n\t\tjustify-content: space-around;\n\t\tmargin: 0.5em;\n\t\tfont-family: \"Roboto\", sans-serif;\n\t\tfont-weight: 300;\n\t\tfont-size: larger;\n\t\tcolor: #707070;\n\t}\n\n\t.SettingsPage_admin_column {\n\t\twidth: 25%;\n\t\ttext-align: left;\n\t\tfont-size: 16px;\n\t\tmargin: 10px 0;\n\t}\n\n\t.SettingsPage_admin_column button {\n\t\tmin-width: 45%;\n\t\tbackground-color: transparent;\n\t\ttext-align: end;\n\t\tborder: none;\n\t\tfont-size: 14px;\n\t}\n\n\t#SettingsPage_btn_Administradores {\n\t\twidth: 12vw;\n\t}\n\n\t/* MyRecordsPage */\n\n\t.MyRecordsPage_main_container {\n\t\twidth: 100vw;\n\t\tmin-height: 80vh;\n\t\tbackground-color: #fafafa;\n\t\tpadding: 5vh 5vw;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t}\n\n\t/* AboutPage */\n\n\t.AboutPage_main_container {\n\t\twidth: 100vw;\n\t\tpadding: 3vh 5vw;\n\t\tmin-height: 83vh;\n\t\tbackground-color: #fafafa;\n\t}\n\n\t.AboutPage_title {\n\t\tdisplay: flex;\n\t\tmargin-bottom: 1.5em;\n\t\tjustify-content: center;\n\t}\n\n\t.AboutPage_title_separator {\n\t\tmargin: 0vh 1vw;\n\t\tborder: 1px solid #6c6565;\n\t}\n\n\t.AboutPage_title_main {\n\t\tfont-size: 19px;\n\t\tcolor: #6c6565;\n\t\talign-items: center;\n\t}\n\n\t.AboutPage_title_main span {\n\t\tcolor: #3b82f5;\n\t\ttext-transform: uppercase;\n\t\tfont-weight: 800;\n\t}\n\n\t.AboutPage_title_name {\n\t\tfont-size: 19px;\n\t\tcolor: #6c6565;\n\t\talign-items: center;\n\t}\n\n\t.AboutPage_title_name span {\n\t\tcolor: #f02323;\n\t\ttext-transform: uppercase;\n\t\tfont-weight: 800;\n\t}\n\n\t.AboutPage_container_division {\n\t\tmargin-top: 1.5em;\n\t\tdisplay: flex;\n\t}\n\n\t.AboutPage_left {\n\t\twidth: 40%;\n\t\ttext-wrap: wrap;\n\t\ttext-align: justify;\n\t}\n\n\t.AboutPage_left a {\n\t\ttext-decoration: none;\n\t\tcolor: inherit;\n\t}\n\n\t.AboutPage_section_tipos {\n\t\twidth: 95%;\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t}\n\n\t.AboutPage_card_tipo {\n\t\twidth: 100px;\n\t\tmargin: 1vw;\n\t}\n\n\t.AboutPage_card_tipo a {\n\t\ttext-decoration: none;\n\t}\n\n\t.AboutPage_card_tipo p {\n\t\tfont-size: 12px;\n\t\tmargin-top: 1vh;\n\t\tmargin-bottom: 0em;\n\t\ttext-align: center;\n\t}\n\n\t.AboutPage_card_icons {\n\t\tmin-width: 100%;\n\t\tmin-height: 90px;\n\t\t/* border: 1px solid #cfcdcd; */\n\t\tbox-shadow: 0px 4px 10px #afc1de;\n\t\tborder-radius: 7px;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tcolor: #6c6565;\n\t\tpadding: 1vh;\n\t}\n\n\t.AboutPage_right {\n\t\twidth: 60%;\n\t\tpadding: 0vh 3vw;\n\t}\n\n\t.AboutPage_Badges {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tjustify-content: left;\n\t}\n\n\t.AboutPage_Badges img {\n\t\tmargin-right: 0.5vw;\n\t\tmargin-top: 1vh;\n\t\tborder-radius: 3px;\n\t\t/* box-shadow: 0px 4px 10px #afc1de; */\n\t}\n\n\t#AboutPage_Dev_Master_div {\n\t\tdisplay: flex;\n\t\tpadding: 1vh 0em;\n\t}\n\n\t#AboutPage_Dev_Contacts {\n\t\tdisplay: flex;\n\t\tjustify-content: space-around;\n\t\tpadding: 0em 1vw;\n\t}\n\n\t.AboutPage_Dev_Badges {\n\t\tmargin-left: 1.5vw;\n\t\tdisplay: flex;\n\t\tjustify-content: left;\n\t\talign-items: center;\n\t}\n\n\t.AboutPage_Dev_Badges a {\n\t\tmargin-right: 1vw;\n\t}\n\n\t/* #AboutPage_Dev_Contacts a{\n        margin-top: 1vh;\n    } */\n\n\t#AboutPage_Dev_Contacts a img {\n\t\tborder-radius: 3px;\n\t}\n\n\t.PopUpErrorLogin_container {\n\t\twidth: 40%;\n\t\tmin-height: 40%;\n\t\tposition: fixed;\n\t\ttop: 50%;\n\t\tleft: 50%;\n\t\ttransform: translate(-50%, -50%);\n\t\tbackground-color: white;\n\t\tbox-shadow: 0px 0px 10px #6c6565;\n\t\tborder-radius: 10px;\n\t\tz-index: 1000;\n\t\ttext-align: center;\n\t}\n\n\t.PopUpErrorLogin_main {\n\t\tcolor: #ffffff;\n\t\tfont-weight: 600;\n\t\tpadding: 1em;\n\t\tfont-size: 25px;\n\t\tborder-radius: 10px 10px 0px 0px;\n\t\tbackground-color: #3b82f5;\n\t}\n\n\t.PopUpErrorLogin_main svg {\n\t\tmargin-right: 15px;\n\t}\n\n\t.PopUpErrorLogin_text {\n\t\tpadding: 2em;\n\t}\n\n\t.PopUpErrorLogin_erro {\n\t\tcolor: red;\n\t\tmargin-top: 1em;\n\t}\n\n\t.PopUpErrorLogin_Dev_Info {\n\t\tborder-top: 1px solid #6c6565;\n\t\tborder-bottom: 1px solid #6c6565;\n\n\t\ttext-transform: uppercase;\n\t\tfont-size: 15px;\n\t\tmargin-top: 0.5em;\n\t}\n\n\t.PopUpErrorLogin_container button {\n\t\tmargin-top: 1vh;\n\t}\n}\n\n@media (max-width: 600px) {\n\t.GeneralError_img_container {\n\t\twidth: 70%;\n\t\tmargin: 2em auto;\n\t}\n\n\t.GeneralErrorPopUp_Content p {\n\t\ttext-align: justify;\n\t}\n\n\t/* WelcomePage */\n\n\t.container_principal_welcome {\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tjustify-content: flex-start;\n\t\talign-content: space-around;\n\t}\n\n\t.container_texto_welcome {\n\t\tmargin-top: 5vh;\n\t\tmin-width: 80vw;\n\t}\n\n\t.texto_banco {\n\t\tfont-size: 20px;\n\t\tfont-weight: 600;\n\t}\n\n\t.texto_recursos {\n\t\tfont-size: 51px;\n\t\tfont-weight: 700;\n\t}\n\n\t.texto_name {\n\t\tfont-size: 17px;\n\t\tfont-weight: 600;\n\t}\n\n\t.btn_login {\n\t\tpadding: 0.5vh 5vw;\n\t\tfont-size: 13px;\n\t\tmin-width: 30vw;\n\t}\n\n\t.container_video {\n\t\tmargin-top: 10vh;\n\t\twidth: 90vw;\n\t}\n\n\t/* HomePage */\n\n\t.HomePage_main_container {\n\t\twidth: 100vw;\n\t\tmin-height: 80vh;\n\t\tpadding: 0vh 0vw;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\tflex-direction: column;\n\t}\n\n\t.HomePage_search_container {\n\t\twidth: 100%;\n\t\tmin-height: 100px;\n\t\tborder-radius: 0px;\n\t\tmargin: 0px;\n\t}\n\n\t.HomePage_middle_text {\n\t\twidth: 90%;\n\t\tmargin: 1vh auto;\n\t\ttext-align: justify;\n\t\tcolor: #878787;\n\t\tfont-size: 20px;\n\t\tfont-weight: 500;\n\t}\n\n\t.HomePage_title {\n\t\twidth: 80%;\n\t\tdisplay: flex;\n\t\talign-content: center;\n\t\talign-self: auto;\n\t\tjustify-content: center;\n\t\tcolor: #ffffff;\n\t\tfont-size: 23px;\n\t\ttext-shadow: 1px 1px 20px #00000095;\n\t\tfont-weight: 600;\n\t\tfont-family: \"Roboto\", sans-serif;\n\t}\n\n\t.HomePage_div_input {\n\t\twidth: 90%;\n\t\tmargin: 30px auto;\n\t\tdisplay: flex;\n\t}\n\n\t/* SearchPage */\n\n\t#notFoundImage {\n\t\twidth: 50%;\n\t}\n\n\t.SearchPage_container_form {\n\t\twidth: 90vw;\n\t\tmargin: 5vh auto;\n\t\tgap: 10px;\n\t\theight: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: space-around;\n\t\talign-items: center;\n\t}\n\n\t.SearchPage_container_form input,\n\t.SearchPage_container_form select {\n\t\twidth: 100%;\n\t}\n\n\t.SearchPage_search_results {\n\t\twidth: 100vw;\n\t\tpadding: 0vh 3vh;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: space-around;\n\t}\n\n\t.SearchPage_Fade_In_Child {\n\t\tmax-width: 100%;\n\t\tmargin: 1vh 0vw;\n\t}\n\n\t.SearchPage_card_result {\n\t\twidth: 100%;\n\t\tmin-height: 0px;\n\t\theight: 10vh;\n\t\tbox-shadow: 0px 4px 10px #958c8c29;\n\t\tbackground-color: #fcfcfc;\n\t\tdisplay: flex;\n\t\tjustify-content: flex-start;\n\t\talign-self: center;\n\t\tfont-family: \"Roboto\", sans-serif;\n\t\tcursor: pointer;\n\t\tborder-radius: 5px;\n\t\tmargin: 0.5vh 0vw;\n\t\tpadding: 0px;\n\t}\n\n\t.SearchPage_card_img {\n\t\twidth: 50%;\n\t\tmargin-right: 2vh;\n\t\tbox-shadow: 0px 4px 10px #958c8c29;\n\t\tborder-radius: 5px;\n\t}\n\n\t.SearchPage_card_type,\n\t.SearchPage_card_reference {\n\t\twidth: 100% !important;\n\t\ttext-align: left;\n\t}\n\n\t.SearchPage_card_description {\n\t\tfont-size: 14px;\n\t\tcolor: #6c6565;\n\t\ttext-overflow: ellipsis;\n\t\toverflow: hidden;\n\t\tfont-weight: lighter;\n\t\twhite-space: nowrap;\n\t\tmax-width: 200px;\n\t}\n\n\t/* RegisterPage */\n\n\t.RegisterPage_container_form {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t}\n\n\t.RegisterPage_container_image {\n\t\twidth: 90vw;\n\t\tmin-height: 50vh;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t}\n\n\t.RegisterPage_container_informations {\n\t\twidth: 90vw;\n\t\tmargin-top: 20px;\n\t}\n\n\t.RegisterPage_description {\n\t\tpadding: 10px;\n\t\tmargin-bottom: 10px;\n\t}\n\n\t.RegisterPage_container_links {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tflex-wrap: wrap;\n\t\twidth: 100%;\n\t\tjustify-content: space-around;\n\t\tpadding: 3vh 0vw;\n\t}\n\n\t.RegisterPage_container_links input {\n\t\twidth: 100%;\n\t\tmargin: 1vh auto;\n\t}\n\n\t.RegisterPage_container_projects {\n\t\tflex-direction: column;\n\t}\n\n\t.RegisterPage_container_projects select {\n\t\twidth: 95%;\n\t\tfont-size: 13px;\n\t\tmargin: 1vh 0vw;\n\t}\n\n\t.RegisterPage_container_origin {\n\t\tflex-direction: column;\n\t}\n\n\t.RegisterPage_container_origin select,\n\t.RegisterPage_container_origin textarea {\n\t\twidth: 100%;\n\t\tmargin-bottom: 1vh;\n\t}\n\n\t/* SettingsPage */\n\n\t.SettingsPage_admin_line {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\twidth: 100%;\n\t\tjustify-content: space-around;\n\t\tborder-bottom: 1px solid #b1b1b1;\n\t\tpadding-bottom: 3vh;\n\t}\n\n\t.SettingsPage_admin_column {\n\t\twidth: 100%;\n\t\ttext-align: left;\n\t}\n\n\t.SettingsPage_admin_column button {\n\t\twidth: 50%;\n\t\tbackground-color: transparent;\n\t\ttext-align: center;\n\t\tborder: none;\n\t}\n\n\t.MyRecordsPage_main_container {\n\t\tpadding: 5vh 0vw;\n\t}\n\n\t/* AboutPage */\n\n\t.AboutPage_title {\n\t\tdisplay: flex;\n\t\tmargin-bottom: 1.5em;\n\t\tjustify-content: center;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t}\n\n\t.AboutPage_title_separator {\n\t\tdisplay: none;\n\t}\n\n\t.AboutPage_container_division {\n\t\tmargin-top: 1.5em;\n\t\tdisplay: flex;\n\t\tflex-direction: column-reverse;\n\t\talign-items: center;\n\t}\n\n\t.AboutPage_left {\n\t\twidth: 90%;\n\t\ttext-wrap: wrap;\n\t\ttext-align: justify;\n\t}\n\n\t.AboutPage_right {\n\t\twidth: 110%;\n\t\tmargin-bottom: 2vh;\n\t}\n\n\t#AboutPage_Dev_Contacts {\n\t\tpadding: 0vh 3vw;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: left;\n\t}\n\n\t.AboutPage_Dev_Badges {\n\t\tmargin-left: -2vw;\n\t\tmargin-top: 1vh;\n\t\tdisplay: flex;\n\t\tjustify-content: left;\n\t\talign-items: center;\n\t}\n\n\t.AboutPage_Dev_Badges a {\n\t\tmargin-right: 1vw;\n\t}\n\n\t.AboutPage_section_tipos {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t}\n\n\t.PopUpErrorLogin_container {\n\t\twidth: 90%;\n\t\tmin-height: 40%;\n\t\tposition: fixed;\n\t\ttop: 50%;\n\t\tleft: 50%;\n\t\ttransform: translate(-50%, -50%);\n\t\tbackground-color: white;\n\t\tbox-shadow: 0px 0px 10px #6c6565;\n\t\tborder-radius: 10px;\n\t\tz-index: 1000;\n\t\ttext-align: center;\n\t}\n\n\t.PopUpErrorLogin_main {\n\t\tcolor: #ffffff;\n\t\tfont-weight: 400;\n\t\tpadding: 0.5em;\n\t\tfont-size: 20px;\n\t\tborder-radius: 10px 10px 0px 0px;\n\t\tbackground-color: #3b82f5;\n\t}\n\n\t.PopUpErrorLogin_main svg {\n\t\tmargin-right: 15px;\n\t}\n\n\t.PopUpErrorLogin_text {\n\t\tpadding-top: 4vh;\n\t\tpadding-bottom: 3vh;\n\t\tfont-size: 15px;\n\t}\n\n\t.PopUpErrorLogin_erro {\n\t\tcolor: red;\n\t\tmargin-top: 1vh;\n\t\tfont-size: 12px;\n\t}\n\n\t.PopUpErrorLogin_Dev_Info {\n\t\tborder-top: 1px solid #6c6565;\n\t\tborder-bottom: 1px solid #6c6565;\n\t\ttext-transform: uppercase;\n\t\tfont-size: 15px;\n\t}\n\n\t.PopUpErrorLogin_container button {\n\t\tmargin-top: 4vh;\n\t}\n\n\t.waitingFor_text {\n\t\tfont-size: 25px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
